/* Übersetzte Texte aus den Sprachdateien (window.tigha.strings); Deutsch als Rückfall */
window.tighaL = window.tighaL || function (k, fb, vars) {
  var s = (window.tigha && window.tigha.strings) || {};
  var v = s[k] || fb || '';
  if (vars) Object.keys(vars).forEach(function (n) { v = v.split('{' + n + '}').join(vars[n]); });
  return v;
};
window.tighaLang = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2);
/* ==========================================================================
   TIGHA — theme.js
   Vanilla JS, keine Abhängigkeiten. Custom Elements + Section-Rendering-API.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.tigha || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ── Sprache: deutsche Seite mit /en-Links (Shopify-Cache) zurückbiegen ── */
  function fixUrl(u) {
    var p = T.badPrefix;
    if (!p || !u || u.charAt(0) !== '/') return u;
    if (u === p || u.indexOf(p + '/') === 0 || u.indexOf(p + '?') === 0) return u.slice(p.length) || '/';
    return u;
  }
  window.tighaFixUrl = fixUrl;
  if (T.badPrefix) {
    var fixEl = function (el) {
      ['href', 'action', 'data-url'].forEach(function (at) {
        var v = el.getAttribute(at); if (v) { var n = fixUrl(v); if (n !== v) el.setAttribute(at, n); }
      });
    };
    $$('a[href],form[action],[data-url]').forEach(fixEl);
    document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) fixEl(a); }, true);
    document.addEventListener('submit', function (e) { if (e.target && e.target.tagName === 'FORM') fixEl(e.target); }, true);
  }
  var ROOT = (T.routes && T.routes.root_url) || '/';

  /* ── Helfer ───────────────────────────────────────────────────────────── */
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    var f = T.moneyFormat || '{{amount_with_comma_separator}} €';
    if (f.indexOf('{{') === -1) return v + ' €';
    return f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function toast(msg, isError) {
    var el = document.getElementById('Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('toast--error', !!isError);
    el.setAttribute('data-show', '');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.removeAttribute('data-show'); }, 3200);
  }
  window.tighaToast = toast;

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  /* ── Overlay-Steuerung (Drawer, Quickview, Suche, Menü) ───────────────── */
  var lastFocus = null;
  // Offene Overlays in Reihenfolge: Größenberater über der Schnellansicht schliesst nur sich selbst
  var ovStack = [];
  function openOverlay(id) {
    var ov = document.getElementById(id);
    if (!ov) return;
    lastFocus = document.activeElement;
    ovStack = ovStack.filter(function (x) { return x !== id; });
    ovStack.push(id);
    ov.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    var f = ov.querySelector('input:not([type=hidden]),button,a[href]');
    if (f) setTimeout(function () { f.focus(); }, 120);
    trapFocus(ov);
  }
  function closeOverlays() {
    var still = ovStack.filter(function (x) { var o = document.getElementById(x); return o && o.hasAttribute('data-open'); });
    if (still.length > 1) {
      document.getElementById(still.pop()).removeAttribute('data-open');
      ovStack = still;
      trapFocus(document.getElementById(still[still.length - 1]));
      return;
    }
    ovStack = [];
    restoreSizeAdvisor();
    $$('.ov[data-open]').forEach(function (o) { o.removeAttribute('data-open'); });
    $$('.facets[data-open]').forEach(function (o) { o.removeAttribute('data-open'); });
    document.body.style.overflow = '';
    releaseTrap();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.tighaOpen = openOverlay;

  /* Größenberater der Schnellansicht: ersetzt für die Dauer der Schnellansicht
     den Berater der Seite (Produktseite) und wird danach wieder zurückgetauscht. */
  var saStash = null;
  function useQuickviewSizeAdvisor(box) {
    var sa = box.querySelector('#SizeAdvisor');
    $$('[data-qv-sa]').forEach(function (x) { if (x !== sa) x.remove(); });
    if (!sa) return;
    var pageSa = $$('#SizeAdvisor').filter(function (x) { return x !== sa && !x.hasAttribute('data-qv-sa'); })[0];
    if (pageSa && !saStash) { saStash = { el: pageSa, parent: pageSa.parentNode, next: pageSa.nextSibling }; pageSa.remove(); }
    sa.setAttribute('data-qv-sa', '');
    document.body.appendChild(sa);
    initSizeAdvisor();
  }
  function restoreSizeAdvisor() {
    $$('[data-qv-sa]').forEach(function (x) { x.remove(); });
    if (saStash) { saStash.parent.insertBefore(saStash.el, saStash.next); saStash = null; }
  }
  window.tighaClose = closeOverlays;

  var trapEl = null, trapHandler = null;
  function trapFocus(el) {
    releaseTrap();
    trapEl = el;
    trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', el)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    el.addEventListener('keydown', trapHandler);
  }
  function releaseTrap() {
    if (trapEl && trapHandler) trapEl.removeEventListener('keydown', trapHandler);
    trapEl = null; trapHandler = null;
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOverlays(); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-overlay-open]');
    if (t) { e.preventDefault(); openOverlay(t.getAttribute('data-overlay-open')); return; }
    var oc = e.target.closest('[data-overlay-close]');
    if (oc || e.target.classList.contains('ov__bg')) {
      /* Links mit Ziel (z. B. "Kollektion ansehen", Produkte im leeren Warenkorb) sollen navigieren, nicht nur schliessen */
      var href = oc && oc.tagName === 'A' ? oc.getAttribute('href') : null;
      if (!href || href.charAt(0) === '#') e.preventDefault();
      closeOverlays();
    }
  });

  /* ── Header: Scroll-Zustand ───────────────────────────────────────────── */
  function initHeader() {
    var h = $('.hdr');
    if (!h) return;
    var over = h.classList.contains('hdr--over');
    var trigger = over ? Math.max(window.innerHeight * 0.7, 200) : 40;
    function on() {
      var y = window.scrollY;
      h.toggleAttribute('data-min', y > 120);
      if (!over) return;
      if (y > trigger) { h.classList.remove('hdr--over'); h.classList.add('hdr--solid'); }
      else { h.classList.add('hdr--over'); h.classList.remove('hdr--solid'); }
    }
    window.addEventListener('scroll', on, { passive: true });
    on();
  }

  /* ── Scroll-Reveal ────────────────────────────────────────────────────── */
  function initReveal() {
    if (!document.body.classList.contains('anim-on') || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  }

  /* ── Akkordeon ────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-acc]');
    if (!t) return;
    var item = t.closest('.acc__i,.faq__i,.facet');
    if (!item) return;
    var open = item.hasAttribute('data-open');
    item.toggleAttribute('data-open', !open);
    t.setAttribute('aria-expanded', String(!open));
    var body = item.querySelector('.acc__b,.facet__b');
    if (body) body.style.display = open ? 'none' : '';
    // Geöffneter Block rückt ins Bild, statt unter der Falz zu bleiben
    if (!open && item.classList.contains('acc__i')) {
      setTimeout(function () {
        var r = item.getBoundingClientRect();
        var top = parseInt(getComputedStyle(item).scrollMarginTop, 10) || 90;
        if (r.top < top || r.bottom > window.innerHeight) {
          window.scrollTo({ top: window.scrollY + r.top - top, behavior: 'smooth' });
        }
      }, 40);
    }
  });

  /* ── Warenkorb ────────────────────────────────────────────────────────── */
  var Cart = {
    add: function (formData, btn) {
      if (btn) btn.classList.add('loading');
      return fetch(T.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (btn) btn.classList.remove('loading');
          if (!res.ok) { toast(res.body.description || res.body.message || T.strings.error, true); return null; }
          Cart.refresh();
          if (T.cartDrawer) openOverlay('CartDrawer'); else toast(T.strings.added || 'Hinzugefügt');
          return res.body;
        }).catch(function () {
          if (btn) btn.classList.remove('loading');
          toast(T.strings.error || 'Fehler', true);
        });
    },
    change: function (line, quantity) {
      return fetchJSON(T.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer,cart-icon,main-cart' })
      }).then(function (cart) { Cart.render(cart); return cart; })
        .catch(function () { toast(T.strings.error || 'Fehler', true); });
    },
    refresh: function () {
      return fetchJSON(ROOT + '?sections=cart-drawer,cart-icon,main-cart')
        .then(function (sections) { Cart.renderSections(sections); });
    },
    render: function (cart) {
      if (cart && cart.sections) Cart.renderSections(cart.sections);
      else Cart.refresh();
    },
    renderSections: function (sections) {
      Object.keys(sections || {}).forEach(function (key) {
        var html = sections[key];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var src = tmp.querySelector('[data-section-content]');
        var dest = document.querySelector('[data-section-target="' + key + '"]');
        if (src && dest) {
          dest.innerHTML = src.innerHTML;
          if (key === 'cart-drawer' || key === 'main-cart') {
            dest.classList.add('cart-updated');
            setTimeout(function () { dest.classList.remove('cart-updated'); }, 500);
          }
        }
      });
      document.dispatchEvent(new CustomEvent('tigha:cart:updated'));
      if (typeof initRecommendations === 'function') initRecommendations();
    }
  };
  window.tighaCart = Cart;

  /* ── Lieferdatum: „Bei dir zwischen Di., 29. und Mi., 30. September" ─────
     Versand am nächsten Werktag (heute, falls Mo–Fr), dann die Werktage
     aus den Theme-Einstellungen dazu. Samstag und Sonntag zählen nicht. */
  function tighaEta(spec) {
    var n = String(spec || '1–2').match(/\d+/g) || ['1', '2'];
    var a = parseInt(n[0], 10), b = parseInt(n[1] || n[0], 10);
    var WD = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
    var MO = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    var addWork = function (d, k) {
      var x = new Date(d.getTime());
      while (x.getDay() === 0 || x.getDay() === 6) x.setDate(x.getDate() + 1);
      while (k > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) k--; }
      return x;
    };
    var today = new Date(); today.setHours(12, 0, 0, 0);
    var d1 = addWork(today, a), d2 = addWork(today, b);
    var f = function (d, withMonth) {
      if (window.tighaLang !== 'de') {
        try { return d.toLocaleDateString(window.tighaLang, withMonth ? { weekday: 'short', month: 'long', day: 'numeric' } : { weekday: 'short', day: 'numeric' }); } catch (e) {}
      }
      return WD[d.getDay()] + ', ' + d.getDate() + '.' + (withMonth ? ' ' + MO[d.getMonth()] : '');
    };
    if (d1.getTime() === d2.getTime()) return tighaL('etaOn', 'Bei dir am {d}', { d: f(d1, true) });
    return tighaL('etaBetween', 'Bei dir zwischen {a} und {b}', { a: f(d1, d1.getMonth() !== d2.getMonth()), b: f(d2, true) });
  }
  window.tighaEta = tighaEta;

  /* ── Countdown in der Ankündigungsleiste ─────────────────────────────── */
  function initCountdown() {
    $$('[data-ann-countdown]').forEach(function (el) {
      var at = Date.parse(el.getAttribute('data-ann-countdown'));
      if (isNaN(at)) return;
      var out = el.querySelector('[data-cd]');
      var tick = function () {
        var ms = at - Date.now();
        if (ms <= 0) { el.textContent = el.getAttribute('data-after') || ''; return false; }
        var sec = Math.floor(ms / 1000), d = Math.floor(sec / 86400), h = Math.floor((sec % 86400) / 3600),
            mi = Math.floor((sec % 3600) / 60), se = sec % 60;
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        out.textContent = (d ? d + ' ' + tighaL('cdD', 'T') + ' · ' : '') + pad(h) + ' ' + tighaL('cdH', 'Std') + ' · ' + pad(mi) + ' ' + tighaL('cdM', 'Min') + ' · ' + pad(se) + ' ' + tighaL('cdS', 'Sek');
        return true;
      };
      if (tick()) { var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000); }
    });
  }
  if (document.readyState !== 'loading') initCountdown(); else document.addEventListener('DOMContentLoaded', initCountdown);

  /* ── Zuletzt angesehen ───────────────────────────────────────────────── */
  function initRecent() {
    var box = $('[data-recent]'); if (!box) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem('tigha:recent') || '[]'); } catch (e) { return; }
    var ex = box.getAttribute('data-exclude');
    list = list.filter(function (h) { return h && h !== ex; }).slice(0, 4);
    if (!list.length) return;
    var grid = box.querySelector('[data-recent-grid]');
    Promise.all(list.map(function (h) {
      return fetch(ROOT + 'products/' + encodeURIComponent(h) + '?section_id=recent-card')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.map(function (t) {
        var tmp = document.createElement('div'); tmp.innerHTML = t;
        var c = tmp.querySelector('.pcard'); return c ? c.outerHTML : '';
      }).join('');
      if (!html) return;
      grid.innerHTML = html; box.hidden = false;
      if (window.tighaWishlist) window.tighaWishlist(box);
    });
  }
  if (document.readyState !== 'loading') initRecent(); else document.addEventListener('DOMContentLoaded', initRecent);

  /* ── Grösse direkt auf der Produktkarte in den Warenkorb ─────────────── */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-card-add]');
    if (!s) { if (e.target.closest('[data-card-sizes]')) e.preventDefault(); return; }
    e.preventDefault(); e.stopPropagation();
    var fd = new FormData();
    fd.append('id', s.getAttribute('data-card-add'));
    fd.append('quantity', '1');
    var pcard = s.closest('.pcard, .crec__i'); var pre = pcard && pcard.getAttribute('data-presale');
    if (pre) fd.append('properties[Lieferung]', tighaL('presaleProp', 'Vorbestellung · Versand ab {d}', { d: pre }));
    s.classList.add('is-busy');
    var p = Cart.add(fd, null);
    if (p && p.then) p.then(function () { s.classList.remove('is-busy'); }); else s.classList.remove('is-busy');
  }, true);
  /* Vorschläge im Warenkorb: + klappt die Grössen auf */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-crec-open]');
    if (!b) return;
    e.preventDefault();
    var c = b.closest('.crec__i'); var open = !c.classList.contains('is-open');
    document.querySelectorAll('.crec__i.is-open').forEach(function (x) { x.classList.remove('is-open'); var y = x.querySelector('[data-crec-open]'); if (y) y.setAttribute('aria-expanded', 'false'); });
    if (open) { c.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-card-add]')) { e.preventDefault(); e.target.click(); }
  });
  function initEta(scope) {
    $$('[data-stock][data-eta]', scope || document).forEach(function (st) {
      var txt = tighaEta(st.getAttribute('data-eta'));
      var sub = st.querySelector('[data-stock-sub]');
      if (!sub) return;
      sub.setAttribute('data-ship', txt);
      if (st.getAttribute('data-state') !== 'out') sub.textContent = txt;
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initEta(); });
  if (document.readyState !== 'loading') initEta();

  /* Express-Kauf ohne Grösse: wie der Kauf-Knopf auf die Grössenwahl hinweisen */
  document.addEventListener('click', function (e) {
    var x = e.target.closest('[data-xpay]');
    if (!x) return;
    var f = x.closest('form[data-add-to-cart]');
    if (!f || f.getAttribute('data-needs-size') !== 'true') return;
    e.preventDefault(); e.stopPropagation();
    var sb = f.querySelector('[type=submit]'); if (sb) sb.click();
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    // Ohne bewusste Wahl jeder Option (Grösse, Ausführung …) geht nichts in den Warenkorb
    if (form.getAttribute('data-needs-size') === 'true') {
      var picker = form.closest('[data-variant-picker]') || document;
      var openGroup = $$('.opt', picker).filter(function (g) {
        return !g.querySelector('.opt__values--swatch') && g.querySelector('input[data-option-index]') && !g.querySelector('input[data-option-index]:checked');
      })[0];
      if (openGroup) {
        var nudge = openGroup.querySelector('[data-size-nudge]');
        if (nudge) { nudge.hidden = false; }
        openGroup.classList.remove('opt--shake'); void openGroup.offsetWidth; openGroup.classList.add('opt--shake');
        var r = openGroup.getBoundingClientRect();
        if (r.top < 90 || r.bottom > window.innerHeight) {
          window.scrollTo({ top: window.scrollY + r.top - 120, behavior: 'smooth' });
        }
        var firstRadio = openGroup.querySelector('input[data-option-index]');
        if (firstRadio) { try { firstRadio.focus({ preventScroll: true }); } catch (x) {} }
        return;
      }
    }
    Cart.add(new FormData(form), e.submitter || form.querySelector('[type=submit]'));
  }, true);

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-line-change]');
    if (q) {
      e.preventDefault();
      var qLine = q.closest('.citem, .cart-line, tr');
      if (qLine) qLine.classList.add('is-busy');
      Cart.change(parseInt(q.getAttribute('data-line'), 10), parseInt(q.getAttribute('data-qty'), 10));
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      var rmLine = rm.closest('.citem, .cart-line, tr');
      if (rmLine) rmLine.classList.add('is-busy');
      Cart.change(parseInt(rm.getAttribute('data-line'), 10), 0);
    }
  });

  /* Grösse direkt im Warenkorb ändern: erst die neue Grösse hinzufügen,
     dann die alte Zeile entfernen — schlägt das Hinzufügen fehl (z. B. kein
     Bestand), bleibt alles wie es war. */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-line-size]');
    if (!sel) return;
    var key = sel.getAttribute('data-key');
    var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    var id = parseInt(sel.value, 10);
    var row = sel.closest('.citem, .cart-row, tr');
    if (row) row.classList.add('is-busy');
    sel.disabled = true;
    fetch(T.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [(function () {
        var it = { id: id, quantity: qty };
        try { var pr = JSON.parse(sel.getAttribute('data-props') || '{}'); if (pr && Object.keys(pr).length) it.properties = pr; } catch (x) {}
        return it;
      })()] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || '');
        return fetchJSON(T.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0, sections: 'cart-drawer,cart-icon,main-cart' })
        });
      })
      .then(function (cart) { Cart.render(cart); })
      .catch(function (err) {
        toast((err && err.message) || T.strings.error || 'Fehler', true);
        Cart.refresh();
      });
  });

  /* Mengensteuerung */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = Math.max(parseInt(input.min || 1, 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Varianten-Auswahl ────────────────────────────────────────────────── */
  function VariantPicker(root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    $$('[data-satc-select]', root).forEach(function (sel) {
      sel.addEventListener('change', function () {
        var i = sel.getAttribute('data-satc-select');
        var r = $$('input[data-option-index="' + i + '"]', root).filter(function (x) { return x.value === sel.value; })[0];
        if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
    var variants = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-add-to-cart]');
    var idInput = form && form.querySelector('input[name="id"]');

    var optCount = variants.length && variants[0].options ? variants[0].options.length : 0;
    function selected() {
      // Werte nach Optionsindex ablegen — ohne gewählte Grösse darf die Farbe nicht auf Index 0 rutschen
      var vals = [];
      for (var k = 0; k < optCount; k++) vals[k] = undefined;
      $$('input[data-option-index]:checked, select[data-option-index]', root).forEach(function (el) {
        vals[parseInt(el.getAttribute('data-option-index'), 10)] = el.value;
      });
      return vals;
    }
    // Galerie zeigt nur die Bilder der gewählten Farbe (data-color am figure); ohne Treffer alle
    function syncGallery(colorValue) {
      var gal = root.querySelector('[data-gallery]');
      if (!gal) return;
      var picked = String(colorValue || '').toLowerCase();
      var any = false;
      Array.prototype.forEach.call(gal.querySelectorAll('figure'), function (f) {
        var c = (f.getAttribute('data-color') || '').toLowerCase();
        var show = !c || !picked || c === picked;
        if (show) { f.removeAttribute('hidden'); any = true; } else { f.setAttribute('hidden', ''); }
      });
      if (!any) {
        Array.prototype.forEach.call(gal.querySelectorAll('figure'), function (f) { f.removeAttribute('hidden'); });
      }
      gal.scrollTo({ left: 0, behavior: 'auto' });
      gal.dispatchEvent(new CustomEvent('gal:refresh'));
    }
    function update() {
      var vals = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      });
      // Verfügbarkeit der Größen anhand der gewählten Farbe
      $$('input[data-option-index]', root).forEach(function (inp) {
        var idx = parseInt(inp.getAttribute('data-option-index'), 10);
        var test = vals.slice();
        test[idx] = inp.value;
        // Noch nicht gewählte Optionen (z. B. Grösse) bleiben offen: verfügbar, wenn irgendeine passende Variante lieferbar ist
        var ok = variants.some(function (vr) {
          return vr.available && vr.options.every(function (o, i) { return test[i] === undefined || test[i] === '' || o === test[i]; });
        });
        // Ausverkaufte Grössen bleiben wählbar (schraffiert), damit das Restock-Feld erreichbar ist
        inp.disabled = false;
        if (ok) inp.removeAttribute('data-soldout'); else inp.setAttribute('data-soldout', '');
      });
      $$('[data-option-value-for]', root).forEach(function (el) {
        var i = parseInt(el.getAttribute('data-option-value-for'), 10);
        el.textContent = vals[i] || '';
      });
      // Auswahl in der mitlaufenden Leiste spiegeln (Wert + Verfügbarkeit je Grösse)
      $$('[data-satc-select]', root).forEach(function (sel) {
        var i = parseInt(sel.getAttribute('data-satc-select'), 10);
        if (vals[i] !== undefined) sel.value = vals[i];
        Array.prototype.forEach.call(sel.options, function (o) {
          var r = $$('input[data-option-index="' + i + '"]', root).filter(function (x) { return x.value === o.value; })[0];
          var so = !!(r && r.hasAttribute('data-soldout'));
          if (!o.hasAttribute('data-base')) o.setAttribute('data-base', o.textContent);
          o.disabled = false;
          o.textContent = o.getAttribute('data-base') + (so ? ' — ' + tighaL('soldOutLower', 'ausverkauft') : '');
        });
      });
      var ship = root.querySelector('[data-satc-ship]');

      var priceEls = $$('[data-price-target]', root);
      var btn = root.querySelector('[data-atc-label]');
      var btnShort = root.querySelector('[data-atc-short]');
      var stock = root.querySelector('[data-stock]');
      // Bestandsanzeige: in / low / out, Text + Unterzeile
      var setStock = function (state, text, sub) {
        if (!stock) return;
        stock.hidden = false;
        stock.setAttribute('data-state', state);
        // Ausverkauft: Kauf-Knopf weg, Benachrichtigung an seine Stelle
        if (state === 'out') root.setAttribute('data-oos', ''); else root.removeAttribute('data-oos');
        var t = stock.querySelector('[data-stock-text]');
        var s2 = stock.querySelector('[data-stock-sub]');
        if (t) t.textContent = text;
        if (s2) s2.textContent = sub != null ? sub : (s2.getAttribute('data-ship') || '');
      };
      // Grössenwert der gewählten Variante (die Gruppe ohne Farbfelder)
      var sizeOf = function (v) {
        var groups = $$('.opt', root), i;
        for (i = 0; i < groups.length; i++) {
          if (!groups[i].querySelector('.opt__values--swatch') && v && v.options) return v.options[i] || '';
        }
        return v && v.options ? v.options[0] : '';
      };
      var outSub = tighaL('outSub', 'Trag dich ein — wir melden uns, sobald sie wieder da ist.');
      // Vorbestellung (Metafeld custom.vorbestellung): andere Texte, gleicher Ablauf
      var pre = root.getAttribute('data-presale');
      var inState = function () { if (pre) setStock('pre', tighaL('preNow', 'Jetzt vorbestellen')); else setStock('in', tighaL('inStock', 'Auf Lager und versandbereit')); };

      // Grösse noch nicht gewählt: neutraler Zustand statt "nicht verfügbar"
      var form0 = root.querySelector('form[data-add-to-cart]');
      var incomplete = vals.some(function (x) { return x === undefined || x === ''; })
        || $$('input[data-option-index]', root).length && $$('.opt', root).some(function (g) {
          return !g.querySelector('.opt__values--swatch') && !g.querySelector('input[data-option-index]:checked');
        });
      if (incomplete) {
        var openGrp = $$('.opt', root).filter(function (g) {
          return !g.querySelector('.opt__values--swatch') && g.querySelector('input[data-option-index]') && !g.querySelector('input[data-option-index]:checked');
        })[0];
        var chooseTxt = tighaL('chooseOpt', '{o} wählen', { o: (openGrp && openGrp.getAttribute('data-opt-name') ? openGrp.getAttribute('data-opt-name') : tighaL('sizeWord', 'Grösse')) });
        // Hinweise der bereits gewählten Gruppen ausblenden
        $$('[data-size-nudge]', root).forEach(function (n) { if (!openGrp || !openGrp.contains(n)) n.hidden = true; });
        var base = variants.filter(function (v) { return v.available; })[0] || variants[0];
        if (btn) btn.textContent = chooseTxt + (base ? ' — ' + money(base.price) : '');
        if (btnShort) btnShort.textContent = chooseTxt;
        $$('[type=submit]', root).forEach(function (s) { s.removeAttribute('aria-disabled'); s.setAttribute('data-choose', ''); });
        if (variants.some(function (x) { return x.available; })) inState();
        else setStock('out', T.strings.soldOut || 'Ausverkauft', outSub);
        if (ship) ship.hidden = true;
        var rs0 = root.querySelector('[data-restock]');
        if (rs0) rs0.hidden = variants.some(function (x) { return x.available; });
        if (form0) form0.setAttribute('data-needs-size', 'true');
        var ci0 = root.getAttribute('data-color-index');
        if (ci0 !== null && ci0 !== '' && vals[parseInt(ci0, 10)]) syncGallery(vals[parseInt(ci0, 10)]);
        return;
      }
      if (form0) form0.setAttribute('data-needs-size', 'false');
      $$('[data-size-nudge]', root).forEach(function (n) { n.hidden = true; });
      $$('[type=submit]', root).forEach(function (s) { s.removeAttribute('data-choose'); });

      if (!match) {
        var na = T.strings.unavailable || 'Nicht verfügbar';
        if (btn) btn.textContent = na;
        if (btnShort) btnShort.textContent = na;
        $$('[type=submit]', root).forEach(function (s) { s.setAttribute('aria-disabled', 'true'); });
        var rs = root.querySelector('[data-restock]');
        if (rs) rs.hidden = false;
        setStock('out', na, outSub);
        return;
      }
      if (idInput) idInput.value = match.id;
      if (window.history.replaceState && !root.closest('.qadd')) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', u);
      }
      priceEls.forEach(function (priceEl) {
        priceEl.innerHTML = '<span class="price__now">' + money(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) priceEl.classList.add('price--sale');
        else priceEl.classList.remove('price--sale');
      });
      // Vergleichspreis + Rabatt-Kennzeichen
      $$('[data-compare-target]', root).forEach(function (el) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          var pct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
          el.innerHTML = '<span class="price__was">' + money(match.compare_at_price) + '</span>' +
                         '<span class="price__badge">&minus;' + pct + '\u00a0%</span>';
        } else { el.innerHTML = ''; }
      });
      var add = pre ? tighaL('preorderBtn', 'Vorbestellen') : (T.strings.addToCart || 'In den Warenkorb');
      var sold = T.strings.soldOut || 'Ausverkauft';
      $$('[type=submit]', root).forEach(function (s) {
        if (match.available) s.removeAttribute('aria-disabled');
        else s.setAttribute('aria-disabled', 'true');
      });
      if (btn) btn.textContent = match.available ? add + ' — ' + money(match.price) : sold;
      if (btnShort) btnShort.textContent = match.available ? add : sold;
      if (stock) {
        // Echter Bestand: knappe Grösse benennen, ausverkaufte Grösse klar sagen
        var sz = sizeOf(match);
        var lowLimit = parseInt(stock.getAttribute('data-low-limit'), 10) || 0;
        var isLow = lowLimit > 0 && typeof match.qty === 'number' && match.qty > 0 && match.qty <= lowLimit;
        if (!match.available) setStock('out', sz ? tighaL('sizeSoldOut', 'Grösse {s} ist ausverkauft', { s: sz }) : (T.strings.soldOut || 'Ausverkauft'), outSub);
        else if (isLow) setStock('low', sz
          ? tighaL(pre ? 'lowSizePre' : 'lowSize', pre ? 'Nur noch {n} in Grösse {s} vorbestellbar' : 'Nur noch {n} in Grösse {s}', { n: match.qty, s: sz })
          : tighaL(pre ? 'lowPre' : 'low', pre ? 'Nur noch {n} vorbestellbar' : 'Nur noch {n} auf Lager', { n: match.qty }));
        else inState();
      }
      if (ship) ship.hidden = !match.available;
      // Ausverkaufte Grösse: Benachrichtigungsfeld zeigen und die Variante mitschreiben
      var restock = root.querySelector('[data-restock]');
      if (restock) {
        restock.hidden = !!match.available;
        var note = restock.querySelector('[data-restock-note]');
        if (note) {
          var titleEl = root.querySelector('.pdp__name');
          var pname = titleEl ? titleEl.textContent.trim() : '';
          note.value = 'Restock: ' + pname + ' — ' + (match.title || (match.options || []).join(' / '));
        }
      }
      // Galerie auf die gewählte Farbe einstellen
      var ci = root.getAttribute('data-color-index');
      var gal = root.querySelector('[data-gallery]');
      if (gal && ci !== null && ci !== '') {
        syncGallery(String(match.options[parseInt(ci, 10)] || ''));
      } else if (match.featured_media) {
        var media = root.querySelector('[data-media-id="' + match.featured_media.id + '"]');
        if (media && media.parentElement) media.parentElement.prepend(media);
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches('input[data-option-index],select[data-option-index]')) update();
    });
    update();
  }
  window.tighaVariantPicker = VariantPicker;

  /* ── Quickview ────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quickview]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var url = b.getAttribute('data-quickview');
    var box = $('#QuickView .qadd');
    if (!box) return;
    box.innerHTML = '<div class="qadd__loading mono">…</div>';
    openOverlay('QuickView');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=quickview')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var content = tmp.querySelector('[data-quickview-content]');
        box.innerHTML = content ? content.innerHTML : html;
        var vp = box.querySelector('[data-variant-picker]');
        if (vp) VariantPicker(vp);
        useQuickviewSizeAdvisor(box);
        var exp = box.querySelector('[data-qadd-expand]');
        if (exp) exp.addEventListener('click', function () {
          var d = box.querySelector('[data-qadd-desc]');
          if (d) d.classList.remove('qadd__desc--clamp');
          exp.remove();
        });
        trapFocus($('#QuickView'));
      })
      .catch(function () { closeOverlays(); toast(T.strings.error || 'Fehler', true); });
  });

  /* ── Predictive Search ────────────────────────────────────────────────── */
  function initSearch() {
    var input = $('[data-predictive-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var url = T.routes.predictive_search_url +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,article,page&resources[limit]=6&section_id=predictive-search';
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var c = tmp.querySelector('[data-section-content]');
          results.innerHTML = c ? c.innerHTML : '';
        });
      }, 220);
    });
  }

  /* ── Kollektion: Filterleiste, Sortierung, Model/Produkt ──────────────── */
  function initCollection() {
    var grid = $('[data-product-grid]');

    // Filter-Panels
    $$('[data-fpanel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-fpanel');
        var panel = document.getElementById(id);
        if (!panel) return;
        var isOpen = panel.hasAttribute('data-open');
        $$('.fpanel[data-open]').forEach(function (p) { p.removeAttribute('data-open'); });
        $$('[data-fpanel]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (!isOpen) { panel.setAttribute('data-open', ''); btn.setAttribute('aria-expanded', 'true'); }
      });
    });

    // Model / Produkt
    $$('[data-view-set]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-view-set');
        if (grid) grid.setAttribute('data-view', v);
        $$('[data-view-set]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        try { localStorage.setItem('tigha:view', v); } catch (err) {}
      });
    });
    try {
      var sv = localStorage.getItem('tigha:view');
      if (sv && grid) {
        grid.setAttribute('data-view', sv);
        $$('[data-view-set]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-view-set') === sv)); });
      }
    } catch (err) {}

    // Filterformular — AJAX
    var form = $('[data-facet-form]');
    if (form) {
      var run = function () {
        var params = new URLSearchParams(new FormData(form));
        // Auf der Suchseite darf der Suchbegriff beim Filtern nicht verloren gehen.
        var cur = new URLSearchParams(window.location.search);
        ['q', 'type', 'options[prefix]'].forEach(function (k) {
          if (cur.has(k)) params.set(k, cur.get(k));
        });
        var sorted = $('[data-sort-option][aria-pressed="true"]');
        if (sorted) params.set('sort_by', sorted.getAttribute('data-sort-option'));
        renderCollection(window.location.pathname + '?' + params.toString());
      };
      form.addEventListener('change', run);
      form.addEventListener('submit', function (e) { e.preventDefault(); run(); });
    }
    // Sortieren als Dropdown
    var sortToggle = $('[data-sort-toggle]');
    var sortDrop = $('#SortDrop');
    if (sortToggle && sortDrop) {
      sortToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = sortDrop.hasAttribute('data-open');
        $$('.fpanel[data-open]').forEach(function (p) { p.removeAttribute('data-open'); });
        $$('[data-fpanel]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (open) { sortDrop.removeAttribute('data-open'); sortToggle.setAttribute('aria-expanded', 'false'); }
        else { sortDrop.setAttribute('data-open', ''); sortToggle.setAttribute('aria-expanded', 'true'); }
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.fbar__right')) {
          sortDrop.removeAttribute('data-open');
          sortToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
    $$('[data-sort-option]').forEach(function (b) {
      b.addEventListener('click', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', b.getAttribute('data-sort-option'));
        u.searchParams.delete('page');
        renderCollection(u.pathname + u.search);
      });
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-facet-remove], .pagination a');
      if (!link) return;
      e.preventDefault();
      renderCollection(link.getAttribute('href'));
    });
  }

  function renderCollection(url) {
    var main = $('[data-collection-root]');
    if (main) main.style.opacity = '.4';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      ['[data-collection-root]', '#FilterBar'].forEach(function (sel) {
        var src = tmp.querySelector(sel), dest = $(sel);
        if (src && dest) {
          dest.innerHTML = src.innerHTML;
          if (key === 'cart-drawer' || key === 'main-cart') {
            dest.classList.add('cart-updated');
            setTimeout(function () { dest.classList.remove('cart-updated'); }, 500);
          }
        }
      });
      if (main) main.style.opacity = '';
      window.history.pushState({}, '', url);
      initCollection();
      if (window.tighaMobileFilter) window.tighaMobileFilter(document);
      if (window.tighaDrag) window.tighaDrag(document);
      initReveal();
      window.scrollTo({ top: (($('[data-collection-top]') || {}).offsetTop || 0) - 120, behavior: 'smooth' });
    }).catch(function () { window.location.href = url; });
  }
  window.addEventListener('popstate', function () { window.location.reload(); });

  /* ── Produkt-Karussell ────────────────────────────────────────────────── */
  function initRails() {
    $$('[data-rail-nav]').forEach(function (btn) {
      if (btn.dataset.railReady === '1') return;
      btn.dataset.railReady = '1';
      btn.addEventListener('click', function () {
        var rail = document.getElementById(btn.getAttribute('data-rail-target'));
        if (!rail) return;
        var first = rail.firstElementChild;
        var step = first ? first.offsetWidth + parseFloat(getComputedStyle(rail).columnGap || 20) : 320;
        rail.scrollBy({ left: step * 2 * parseInt(btn.getAttribute('data-rail-nav'), 10), behavior: 'smooth' });
      });
    });
  }

  /* ── Lightbox ─────────────────────────────────────────────────────────── */
  function initLightbox() {
    if (!$('#Lightbox')) $$('[data-zoom]').forEach(function (i) { i.removeAttribute('data-zoom'); });
    var lb = $('#Lightbox');
    if (!lb) return;
    document.addEventListener('click', function (e) {
      var img = e.target.closest('[data-zoom]');
      if (img) {
        lb.querySelector('img').src = img.getAttribute('data-zoom-src') || img.src;
        lb.setAttribute('data-open', '');
        document.body.style.overflow = 'hidden';
        return;
      }
      if (e.target.closest('#Lightbox')) {
        lb.removeAttribute('data-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ── Größenberater ────────────────────────────────────────────────────── */
  /*
     Zwei Wege, in dieser Reihenfolge:

     1. Modellgenau. Liegt für die Jacke eine Maßtabelle vor, rechnen wir mit
        ihren echten Maßen. Aus Körpergrösse und Gewicht schätzen wir den
        Brustumfang, daraus die nötige Schulterbreite. Dann prüfen wir jede
        Größe: Ist die Schulter breit genug? Wie viel Luft bleibt über der
        Brust? Gewählt wird die Größe, deren Luft der gewünschten Passform am
        nächsten kommt — die Schulter hat Vorrang, denn Weite gibt mit der
        Zeit nach, eine Schulternaht nicht.

     2. Rückfall. Ohne Maßtabelle bleibt die alte Größentabelle.

     Woher die Zielzugabe kommt: Über alle Herrenmodelle liegt der Brustumfang
     in Größe M im Mittel bei 109 cm, bei den Damenmodellen bei 98 cm. Die
     bestehende tigha-Größentabelle nennt für M einen Körperumfang von 96–102
     (Herren) bzw. 88–92 (Damen). Die Differenz — rund 10 cm bei Herren, rund
     8 cm bei Damen — ist die durchschnittlich gewollte Zugabe. Beide Werte
     stehen in den Theme-Einstellungen und gehören nachjustiert, sobald echte
     Umtauschgründe vorliegen.
  */
  function initSizeAdvisor() {
    var root = $('#SizeAdvisor');
    if (!root) {
      // Kein Berater vorhanden → Knopf nicht als Blindgänger stehen lassen
      $$('[data-overlay-open="SizeAdvisor"]').forEach(function (b) { b.hidden = true; });
      return;
    }
    if (root.__saInit) return;
    root.__saInit = true;
    var box = root.querySelector('.sa');
    var sex = (box && box.getAttribute('data-sex') === 'w') ? 'w' : 'm';
    var easeTarget = parseFloat(box && box.getAttribute('data-ease'));
    if (!easeTarget) easeTarget = (sex === 'w') ? 8 : 10;

    /* Model als Anker (01.10.2026): Grösse + Gewicht des Models aus dem Produkt.
       Die Luft, die das Model in seiner Grösse hat, wird zur Zielzugabe dieser Jacke. */
    var mH = parseFloat(box && box.getAttribute('data-model-h'));
    var mW = parseFloat(box && box.getAttribute('data-model-w'));
    var mS = ((box && box.getAttribute('data-model-size')) || '').trim();
    var mNote = (box && box.getAttribute('data-model-note')) || '';
    var shAdj = 0, anchored = false;

    /* ---- Maße dieses Modells ---- */
    var FIT = null;
    var fitEl = root.querySelector('[data-size-fit]');
    if (fitEl) {
      var rows = {};
      fitEl.textContent.split('\n').forEach(function (line) {
        var i = line.indexOf(':');
        if (i < 1) return;
        rows[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
      });
      var nums = function (v) {
        return (v || '').split(',').map(function (x) { return parseFloat(String(x).replace(',', '.')); });
      };
      if (rows.sizes && rows.brust) {
        FIT = {
          sizes: rows.sizes.split(',').map(function (x) { return x.trim(); }),
          brust: nums(rows.brust),
          schulter: nums(rows.schulter),
          aermel: nums(rows.aermel)
        };
        if (FIT.brust.length !== FIT.sizes.length) FIT = null;
      }
    }

    /* ---- Rückfalltabelle ---- */
    if (FIT && mH > 0 && mW > 0 && mS) {
      var mi = FIT.sizes.map(function (x) { return x.toUpperCase(); }).indexOf(mS.toUpperCase());
      if (mi >= 0 && !isNaN(FIT.brust[mi])) {
        var mc = estChest(mH, mW);
        easeTarget = Math.max(0, Math.min(40, FIT.brust[mi] * 2 - effChest(mc)));
        if (FIT.schulter && !isNaN(FIT.schulter[mi])) shAdj = Math.min(0, FIT.schulter[mi] - needShoulder(mc));
        anchored = true;
      }
    }

    var dataEl = root.querySelector('[data-size-table]');
    var table = [];
    var note = '';
    try {
      var parsed = JSON.parse((dataEl ? dataEl.textContent : '').trim() || '{}');
      if (typeof parsed === 'string') parsed = JSON.parse(parsed);
      table = parsed.sizes || [];
      note = parsed.note || '';
    } catch (err) { table = []; }

    var out = root.querySelector('[data-size-out]');
    var btn = root.querySelector('[data-size-calc]');
    if (!btn) return;

    function range(v) { return Array.isArray(v) ? v : [v, v]; }
    function dist(v, r) {
      var lo = r[0], hi = r[1], span = (hi - lo) || 1;
      if (v < lo) return (lo - v) / span;
      if (v > hi) return (v - hi) / span;
      return 0;
    }
    function t(key, fallback) { return (T.strings && T.strings[key]) || fallback; }
    function r1(n) { return (Math.round(n * 10) / 10).toString().replace('.', ','); }

    /*
       Brustumfang aus Größe und Gewicht.

       Der Rumpf ist grob ein Zylinder: Das Gewicht wächst mit Höhe mal
       Umfang zum Quadrat, also Umfang ~ Wurzel(Gewicht / Höhe). Der Faktor
       ist so geeicht, dass 1,80 m / 78 kg auf 100 cm kommt (Herren) und
       1,68 m / 60 kg auf 88 cm (Damen).

       Das trifft im Mittel, streut aber ±4 bis 5 cm. Wer nachgemessen hat,
       trägt den Wert ein — dann rechnen wir damit und nicht mit der Schätzung.
    */
    function estChest(H, W) {
      return (sex === 'w' ? 14.73 : 15.19) * Math.sqrt(W / (H / 100));
    }
    /* Passende Schulterbreite der Jacke, Naht zu Naht, inkl. üblicher Zugabe. */
    function needShoulder(chest) {
      return sex === 'w' ? 0.40 * chest + 2.4 : 0.45 * chest + 1.0;
    }
    /*
       Bei Damenmodellen wird die Brust der Jacke unter dem Arm gemessen, der
       Brustumfang des Körpers aber an der stärksten Stelle darüber. Die
       Differenz liegt erfahrungsgemäß bei etwa 4 cm.
    */
    function effChest(chest) { return sex === 'w' ? chest - 4 : chest; }

    function easeWanted(pref) {
      if (pref === 'tight') return easeTarget - 4;
      if (pref === 'loose') return easeTarget + 5;
      return easeTarget;
    }

    /* ---- Weg 1: mit den Maßen der Jacke ---- */
    function calcFromFit(H, W, C, pref) {
      var estimated = !C;
      var chest = C || estChest(H, W);
      var body = effChest(chest);
      var needSh = needShoulder(chest) + shAdj;
      var want = easeWanted(pref);

      var rowsOut = FIT.sizes.map(function (s, i) {
        var circ = FIT.brust[i] * 2;
        var sh = FIT.schulter && !isNaN(FIT.schulter[i]) ? FIT.schulter[i] : null;
        return {
          i: i, size: s, circ: circ, ease: circ - body, sh: sh,
          shOk: sh === null ? true : (sh >= needSh - 0.5),
          shGap: sh === null ? 0 : (sh - needSh)
        };
      });

      /*
         Bewertung statt harter Grenze. Eine zu schmale Schulter wiegt schwer,
         aber sie schliesst eine Grösse nicht auf den Zehntelmillimeter aus —
         sonst kippt die Empfehlung bei 0,1 cm Unterschied um eine ganze Grösse.
         Die Schätzung des Brustumfangs ist dafür viel zu grob.
      */
      rowsOut.forEach(function (r) {
        var sc = Math.abs(r.ease - want);
        if (r.sh !== null && r.shGap < 0) sc += -r.shGap * 3.5;   // Schulter zu schmal
        if (r.ease < 2) sc += (2 - r.ease) * 3;                    // geht gar nicht zu
        r.score = sc;
      });
      var ranked = rowsOut.slice().sort(function (a, b) { return a.score - b.score; });
      var best = ranked[0];
      var alt = ranked[1] || null;
      var fits = rowsOut.filter(function (r) { return r.shOk && r.ease >= 2; });

      var reasons = [];
      reasons.push({
        k: t('saChestLabel', 'Brust'),
        v: tighaL('saJacketEase', '{c} cm Jacke · {e} cm Luft', { c: r1(best.circ), e: r1(best.ease) }),
        s: best.ease < want - 4 ? 'tight' : (best.ease > want + 5 ? 'loose' : 'ok')
      });
      if (best.sh !== null) {
        reasons.push({
          k: t('saShoulderLabel', 'Schulter'),
          v: r1(best.sh) + ' cm · ' + (best.shGap >= 0 ? t('saShoulderOk', 'passt auf deine Schulter') : t('saShoulderNarrow', 'knapp')),
          s: best.shGap >= -0.5 ? 'ok' : 'tight'
        });
      }
      if (FIT.aermel && !isNaN(FIT.aermel[best.i])) {
        reasons.push({ k: t('saSleeveLabel', 'Ärmel'), v: r1(FIT.aermel[best.i]) + ' cm', s: 'ok' });
      }

      /* Ehrliche Hinweise, wenn die Größe nicht sauber aufgeht. */
      var warn = '';
      if (!fits.length) {
        warn = t('saNoneFits', 'Diese Jacke fällt für deine Maße knapp aus — die nächstgrößere Größe gibt es nicht.');
      } else if (best.shGap < -0.3 && best.i < rowsOut.length - 1) {
        /* Ehrlich bleiben: Weite gibt nach, die Schulternaht nicht. */
        warn = t('saShoulderTight', 'Die Schulter wird knapp. Wenn du breit gebaut bist, nimm lieber {n}.')
          .replace('{n}', rowsOut[best.i + 1].size);
      } else if (best.i === rowsOut.length - 1 && best.ease < want - 4) {
        warn = t('saRunsSmall', 'Dieser Schnitt fällt klein aus. {s} ist die größte Größe und sitzt eng.').replace('{s}', best.size);
      } else if (best.i === 0 && best.ease > want + 6) {
        warn = t('saRunsLarge', 'Dieser Schnitt fällt groß aus. {s} ist die kleinste Größe und sitzt betont locker.').replace('{s}', best.size);
      } else if (best.shGap > 2.5) {
        warn = t('saDropShoulder', 'Die Schulter sitzt bei diesem Schnitt bewusst etwas weiter — das ist so gewollt.');
      }

      var head = (estimated
        ? t('saFromBody', 'Bei {h} cm und {w} kg rechnen wir mit rund {c} cm Brustumfang.')
            .replace('{h}', H).replace('{w}', W).replace('{c}', Math.round(chest))
        : t('saFromChest', 'Mit {c} cm Brustumfang.').replace('{c}', Math.round(chest)));

      if (anchored && mNote) head += ' ' + mNote;
      return { best: best, alt: alt, rows: rowsOut, reasons: reasons, warn: warn, head: head, sizes: FIT.sizes };
    }

    /* ---- Weg 2: alte Tabelle ---- */
    function calcFromTable(H, W, C, pref) {
      var shift = pref === 'tight' ? -1 : (pref === 'loose' ? 1 : 0);
      var scored = table.map(function (s, i) {
        var d = dist(H, range(s.height)) * 0.8 + dist(W, range(s.weight)) * 1.4;
        if (C && s.chest) d += dist(C, range(s.chest)) * 1.8;
        return { i: i, size: s.size, d: d };
      }).sort(function (a, b) { return a.d - b.d; });
      var idx = Math.min(table.length - 1, Math.max(0, scored[0].i + shift));
      var second = scored[1] || scored[0];
      return {
        best: { i: idx, size: table[idx].size },
        alt: { i: second.i, size: second.size },
        rows: table.map(function (s, i) { return { i: i, size: s.size }; }),
        reasons: [], warn: note,
        head: (scored[0].d < 0.55
          ? t('sizeConfident', 'Bei {h} cm und {w} kg passt dir <b>{s}</b> am besten.')
              .replace('{h}', H).replace('{w}', W).replace('{s}', table[idx].size)
          : t('sizeBetween', 'Du liegst zwischen zwei Größen. Wir empfehlen <b>{s}</b>, <b>{a}</b> ist die Alternative.')
              .replace('{s}', table[idx].size).replace('{a}', second.size)),
        sizes: table.map(function (s) { return s.size; })
      };
    }

    btn.addEventListener('click', function () {
      var H = parseFloat(root.querySelector('#SaHeight').value);
      var W = parseFloat(root.querySelector('#SaWeight').value);
      var C = parseFloat(root.querySelector('#SaChest').value) || 0;
      var pref = root.querySelector('#SaFit').value || 'normal';

      if (!FIT && !table.length) {
        out.innerHTML = '<p class="mono" style="color:var(--accent)">' + t('sizeNoData', 'Für diesen Artikel sind noch keine Maße hinterlegt.') + '</p>';
        out.setAttribute('data-show', ''); return;
      }
      if ((!H || !W) && !C) {
        out.innerHTML = '<p class="mono" style="color:var(--accent)">' + t('sizeMissing', 'Bitte Körpergrösse und Gewicht angeben.') + '</p>';
        out.setAttribute('data-show', ''); return;
      }
      if ((!H || !W) && C) { H = H || 0; W = W || 0; }

      var res = FIT ? calcFromFit(H, W, C, pref) : calcFromTable(H, W, C, pref);
      var cols = 'grid-template-columns:repeat(' + res.sizes.length + ',1fr)';

      out.innerHTML =
        '<span class="mono" style="color:var(--ink-55)">' + t('sizeResult', 'Deine Empfehlung') + '</span>' +
        '<div class="sa__size">' + res.best.size + '</div>' +
        '<div class="sa__bar" style="' + cols + '">' + res.rows.map(function (r) {
          return '<span ' + (r.i === res.best.i ? 'data-on' : (res.alt && r.i === res.alt.i ? 'data-near' : '')) + '></span>';
        }).join('') + '</div>' +
        '<div class="sa__legend" style="' + cols + '">' + res.sizes.map(function (s) { return '<span>' + s + '</span>'; }).join('') + '</div>' +
        '<p class="sa__head">' + res.head + '</p>' +
        (res.reasons.length
          ? '<ul class="sa__why">' + res.reasons.map(function (r) {
              return '<li data-s="' + r.s + '"><span class="mono">' + r.k + '</span><span>' + r.v + '</span></li>';
            }).join('') + '</ul>'
          : '') +
        (res.alt && res.alt.size !== res.best.size && res.reasons.length
          ? '<p class="sa__alt mono">' + t('saAlt', 'Lieber {d}? Dann {a}.')
              .replace('{d}', res.alt.ease > res.best.ease ? t('saMore', 'etwas mehr Luft') : t('saLess', 'etwas enger'))
              .replace('{a}', res.alt.size) + '</p>'
          : '') +
        (res.warn ? '<p class="sa__warn">' + res.warn + '</p>' : '') +
        '<button type="button" class="btn btn--wide" style="margin-top:18px" data-size-apply="' + res.best.size + '"><span>' +
          t('sizeApply', 'Größe übernehmen').replace('{s}', res.best.size) + '</span></button>';
      out.setAttribute('data-show', '');
    });

    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-size-apply]');
      if (!a) return;
      var size = a.getAttribute('data-size-apply');
      // In der Schnellansicht deren Grössen treffen, nicht die der Seite darunter
      var scope = (root.hasAttribute('data-qv-sa') && $('#QuickView .qadd')) || document;
      var input = Array.prototype.slice.call(scope.querySelectorAll('.opt__values--btn input'))
        .find(function (i) { return i.value === size && !i.disabled; });
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      closeOverlays();
    });
  }


  /* ── Laufband: so viele Kopien, dass der Loop bei jeder Breite lückenlos ist ─ */
  function initMarquee() {
    $$('.ann__track').forEach(function (track) {
      var ann = track.parentElement;
      if (!ann || ann.classList.contains('ann--static')) return;
      var unit = track.firstElementChild;
      if (!unit) return;
      if (!track.dataset.unit) track.dataset.unit = unit.outerHTML;
      var html = track.dataset.unit;

      function fit() {
        track.style.animation = 'none';
        track.innerHTML = html;
        var w = track.firstElementChild.getBoundingClientRect().width;
        if (!w) return;
        var need = Math.max(1, Math.ceil(ann.getBoundingClientRect().width / w));
        track.innerHTML = new Array(need * 2 + 1).join(html); /* immer gerade Anzahl */
        var half = w * need;
        track.style.animation = '';
        track.style.animationDuration = Math.max(18, Math.round(half / 55)) + 's';
      }
      fit();
      var t;
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 180); });
    });
  }


  /* ── Mitlaufende Kaufleiste ───────────────────────────────────────────── */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    if (!bar) return;
    var anchor = $('.pdp__actions');
    var foot = $('.ftr') || $('footer');
    if (!anchor) return;
    bar.hidden = false;

    var pastAnchor = false, atFoot = false;
    function apply() {
      var show = pastAnchor && !atFoot;
      if (show) bar.setAttribute('data-show', '');
      else bar.removeAttribute('data-show');
      // Der Nach-oben-Knopf weicht der Leiste aus (Höhe als CSS-Variable)
      document.documentElement.classList.toggle('satc-on', show);
      if (show) document.documentElement.style.setProperty('--satc-h', bar.offsetHeight + 'px');
    }
    if (!('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        // erst zeigen, wenn der Kaufbereich nach OBEN aus dem Bild ist
        pastAnchor = !e.isIntersecting && e.boundingClientRect.top < 0;
        apply();
      });
    }, { rootMargin: '0px 0px -20% 0px' }).observe(anchor);

    if (foot) {
      // erst ausblenden, wenn der Fußbereich wirklich das Bild einnimmt
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { atFoot = e.isIntersecting; apply(); });
      }, { rootMargin: '0px 0px -60% 0px' }).observe(foot);
    }
  }


  /* ── Empfehlungen nachladen (Produktseite & Warenkorb) ────────────────── */
  function initRecommendations(scope) {
    $$('[data-recommendations]', scope || document).forEach(function (el) {
      if (el.dataset.loading) return;
      var url = fixUrl(el.getAttribute('data-url'));
      if (!url) { el.remove(); return; }
      el.dataset.loading = '1';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var block = tmp.querySelector('[data-recommendations-content]') || tmp.querySelector('section.sec');
          // Produktseite liefert .pcard, der Warenkorb .crec__i — beides zählt
          if (block && block.querySelector('a[href]')) {
            el.replaceWith(block);
            initReveal();
            initRails();
            if (window.tighaDrag) window.tighaDrag(document);
          } else {
            el.remove();
          }
        })
        .catch(function () { el.remove(); });
    });
  }

  /* ── Init ─────────────────────────────────────────────────────────────── */
  function init() {
    initHeader();
    initMarquee();
    initReveal();
    initSearch();
    initCollection();
    initLightbox();
    initSizeAdvisor();
    initStickyAtc();
    initRecommendations();
    initRails();
    $$('[data-variant-picker]').forEach(VariantPicker);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Shopify Theme Editor
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', function (e) {
    var ov = e.target.querySelector('.ov');
    if (ov) openOverlay(ov.id);
  });
})();

/* ── Filter auf dem Handy auf- und zuklappen ─────────────────────────────── */
function initMobileFilter(scope) {
  var root = scope || document;
  root.querySelectorAll('[data-mfilter]').forEach(function (btn) {
    if (btn.dataset.mfReady === '1') return;
    btn.dataset.mfReady = '1';
    btn.addEventListener('click', function () {
      var bar = btn.closest('.fbar');
      if (!bar) return;
      var open = bar.hasAttribute('data-mopen');
      if (open) { bar.removeAttribute('data-mopen'); } else { bar.setAttribute('data-mopen', ''); }
      bar.querySelectorAll('[data-mfilter]').forEach(function (b) {
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
      if (open) bar.scrollIntoView({ block: 'nearest' });
    });
  });
}
document.addEventListener('DOMContentLoaded', function () { initMobileFilter(document); });
document.addEventListener('shopify:section:load', function (e) { initMobileFilter(e.target); });
window.tighaMobileFilter = initMobileFilter;

/* ── Produktgalerie: wischen, Punkte, Filter nach Farbe ─────────────────── */
function initGallerySwipe(scope) {
  var root = scope || document;
  root.querySelectorAll('[data-gallery]').forEach(function (gal) {
    if (gal.dataset.galReady === '1') { gal.dispatchEvent(new CustomEvent('gal:refresh')); return; }
    gal.dataset.galReady = '1';

    var wrap = gal.parentElement;
    var dots = wrap ? wrap.querySelector('[data-gallery-dots]') : null;
    var figures = [];

    function visible() {
      return Array.prototype.filter.call(gal.querySelectorAll('figure'), function (f) {
        return !f.hasAttribute('hidden');
      });
    }

    function sync() {
      if (!dots || !figures.length) return;
      var mid = gal.scrollLeft + gal.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      figures.forEach(function (f, i) {
        var d = Math.abs(f.offsetLeft + f.offsetWidth / 2 - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      Array.prototype.forEach.call(dots.children, function (b, n) {
        if (n === best) { b.setAttribute('data-active', ''); } else { b.removeAttribute('data-active'); }
      });
    }

    function build() {
      figures = visible();
      if (!dots) return;
      dots.innerHTML = '';
      if (figures.length < 2) return;
      figures.forEach(function (f, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (dots.getAttribute('aria-label') || 'Bild') + ' ' + (i + 1));
        if (i === 0) b.setAttribute('data-active', '');
        b.addEventListener('click', function () {
          gal.scrollTo({ left: f.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
      sync();
    }

    var raf;
    gal.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });

    gal.addEventListener('gal:refresh', build);
    window.addEventListener('resize', function () { sync(); });
    build();
  });
}
document.addEventListener('DOMContentLoaded', function () { initGallerySwipe(document); });
document.addEventListener('shopify:section:load', function (e) { initGallerySwipe(e.target); });
window.tighaGallery = initGallerySwipe;

/* ── Merken: bleibt im Browser gespeichert ──────────────────────────────── */
var Wish = (function () {
  var KEY = 'tigha:wishlist';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    badge();
    document.dispatchEvent(new CustomEvent('tigha:wishlist', { detail: { list: list } }));
  }
  function has(handle) { return read().indexOf(handle) > -1; }
  function toggle(handle) {
    var list = read(), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    write(list);
    return i === -1;
  }
  function remove(handle) {
    var list = read(), i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); write(list); }
  }
  /* Zähler am Kopf — zeigt nichts, solange nichts gemerkt ist */
  function badge() {
    var n = read().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-wish-link]').forEach(function (el) {
      el.setAttribute('data-empty', n === 0 ? 'true' : 'false');
    });
  }
  return { read: read, write: write, has: has, toggle: toggle, remove: remove, badge: badge };
})();

function initWishlist(scope) {
  (scope || document).querySelectorAll('[data-wish]').forEach(function (btn) {
    if (btn.dataset.wishReady === '1') return;
    btn.dataset.wishReady = '1';
    var handle = btn.getAttribute('data-wish');
    var set = function (on) { btn.setAttribute('aria-pressed', on ? 'true' : 'false'); };
    set(Wish.has(handle));
    btn.addEventListener('click', function () { set(Wish.toggle(handle)); });
  });
  Wish.badge();
}
document.addEventListener('DOMContentLoaded', function () { initWishlist(document); });
document.addEventListener('shopify:section:load', function (e) { initWishlist(e.target); });
window.tighaWishlist = initWishlist;

/* ── Schienen: mit gedrückter Maustaste ziehen ───────────────────────────── */
(function () {
  'use strict';

  var SEL = '.rail, .h5 .slider';

  function scrollable(rail) { return rail.scrollWidth > rail.clientWidth + 4; }

  function init(scope) {
    (scope || document).querySelectorAll(SEL).forEach(function (rail) {
      if (rail.dataset.dragReady === '1') return;
      rail.dataset.dragReady = '1';

      var down = false, moved = 0, startX = 0, startLeft = 0, snap = '', behav = '';

      rail.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || e.pointerType !== 'mouse' || !scrollable(rail)) return;
        down = true; moved = 0;
        startX = e.clientX; startLeft = rail.scrollLeft;
        snap = rail.style.scrollSnapType; behav = rail.style.scrollBehavior;
        rail.style.scrollSnapType = 'none';
        rail.style.scrollBehavior = 'auto';
        rail.classList.add('is-dragging');
      });

      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) {
          if (rail.setPointerCapture && e.pointerId != null && !rail.hasPointerCapture(e.pointerId)) {
            try { rail.setPointerCapture(e.pointerId); } catch (err) {}
          }
          e.preventDefault();
        }
        moved = Math.max(moved, Math.abs(dx));
        rail.scrollLeft = startLeft - dx;
      });

      function release(e) {
        if (!down) return;
        down = false;
        rail.style.scrollSnapType = snap;
        rail.style.scrollBehavior = behav;
        rail.classList.remove('is-dragging');
        if (e && rail.releasePointerCapture && e.pointerId != null) {
          try { rail.releasePointerCapture(e.pointerId); } catch (err) {}
        }
        // Nach dem Ziehen darf der Klick kein Produkt öffnen
        if (moved > 6) {
          var kill = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          rail.addEventListener('click', kill, { capture: true, once: true });
          setTimeout(function () { rail.removeEventListener('click', kill, true); }, 60);
        }
      }
      rail.addEventListener('pointerup', release);
      rail.addEventListener('pointercancel', release);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.tighaDrag = init;
})();

/* ── Gutscheincode einlösen ─────────────────────────────────────────────── */
(function () {
  'use strict';

  function texts() { return (window.tigha && window.tigha.strings) || {}; }

  function apply(box) {
    var field = box.querySelector('[name="discount"]');
    var btn = box.querySelector('[data-discount-apply]');
    var msg = box.querySelector('[data-discount-msg]');
    var code = (field.value || '').trim();
    if (!code) { field.focus(); return; }

    btn.setAttribute('aria-busy', 'true');
    if (msg) { msg.hidden = true; msg.removeAttribute('data-ok'); }

    // Shopify übernimmt den Code über diese Adresse in den Warenkorb.
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
      method: 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json' }
    })
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Shopify nimmt einen ungültigen Code gar nicht erst in den Warenkorb auf.
        var ok = false;
        var codes = cart.discount_codes || [];
        for (var i = 0; i < codes.length; i++) {
          var c = codes[i];
          if (String(c.code).toLowerCase() === code.toLowerCase() && c.applicable !== false) ok = true;
        }
        btn.removeAttribute('aria-busy');
        if (ok) {
          if (window.tighaCart && window.tighaCart.refresh) { window.tighaCart.refresh(); }
          else { window.location.reload(); }
          return;
        }
        if (msg) {
          msg.textContent = texts().discountError || 'Code ungültig oder nicht anwendbar.';
          msg.hidden = false;
        }
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-discount-apply]');
    if (!btn) return;
    e.preventDefault();
    apply(btn.closest('[data-discount]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var f = e.target.closest('[data-discount] [name="discount"]');
    if (!f) return;
    e.preventDefault();
    apply(f.closest('[data-discount]'));
  });
})();

/* ── „Weiterlesen": lange Texte einklappen ───────────────────────────────── */
function initMore(scope) {
  (scope || document).querySelectorAll('[data-more]').forEach(function (box) {
    if (box.dataset.moreReady === '1') return;
    box.dataset.moreReady = '1';

    var body = box.querySelector('[data-more-body]');
    var btn  = box.querySelector('[data-more-toggle]');
    var lab  = box.querySelector('[data-more-label]');
    if (!body || !btn) return;

    // Nur einklappen, wenn wirklich etwas abgeschnitten wird.
    function overflows() { return body.scrollHeight > body.clientHeight + 4; }

    function measure() {
      if (box.getAttribute('aria-busy') === 'true') return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (open) return;
      if (overflows()) {
        btn.hidden = false;
      } else {
        btn.hidden = true;
        box.removeAttribute('data-collapsed');
      }
    }

    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure).catch(function () {});

    function expand() {
      // Erst den Zielzustand herstellen (mehrspaltig), dann von der alten Höhe
      // dorthin fahren — sonst stimmt das Ziel der Animation nicht.
      var start = body.clientHeight;
      box.removeAttribute('data-collapsed');
      body.style.transition = 'none';
      body.style.maxHeight = 'none';
      var target = body.scrollHeight;
      body.style.maxHeight = start + 'px';
      void body.offsetHeight;
      body.style.transition = '';
      requestAnimationFrame(function () { body.style.maxHeight = target + 'px'; });
      window.setTimeout(function () {
        if (btn.getAttribute('aria-expanded') === 'true') body.style.maxHeight = 'none';
      }, 480);
    }

    function collapse() {
      body.style.maxHeight = body.scrollHeight + 'px';
      void body.offsetHeight;
      box.setAttribute('data-collapsed', '');
      requestAnimationFrame(function () { body.style.maxHeight = ''; });
      var top = box.getBoundingClientRect().top;
      if (top < 0) window.scrollBy({ top: top - 90, behavior: 'smooth' });
    }

    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (lab) lab.textContent = btn.getAttribute(isOpen ? 'data-more-more' : 'data-more-less') || lab.textContent;
      if (isOpen) collapse(); else expand();
    });

    // Bei Größenänderung neu bewerten (Umbruch ändert die Zeilenzahl).
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { measure(); });
      ro.observe(body);
    } else {
      window.addEventListener('resize', measure);
    }
  });
}
document.addEventListener('DOMContentLoaded', function () { initMore(document); });
document.addEventListener('shopify:section:load', function (e) { initMore(e.target); });
window.tighaMore = initMore;


/* Mega-Menue: schliesst beim Scrollen, oeffnet erst nach kurzem Hover */
(function(){
  var hdr = document.querySelector('.hdr, header[class*="hdr"]') || document.querySelector('.shopify-section--header');
  if(!hdr) return;
  var t = null;
  window.addEventListener('scroll', function(){
    hdr.classList.add('hdr--scrolling');
    if(t) clearTimeout(t);
    t = setTimeout(function(){ hdr.classList.remove('hdr--scrolling'); }, 350);
  }, {passive:true});
  var nav = hdr.querySelector('.hdr__nav');
  if(nav) nav.addEventListener('mouseenter', function(){ hdr.classList.remove('hdr--scrolling'); });
})();


/* ── Nach oben ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  var btn = document.querySelector('.to-top');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toTop() {
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  }

  // Jeder Knopf mit data-scroll-top fuehrt nach oben (schwebend und in der Fusszeile)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-scroll-top]');
    if (!t) return;
    e.preventDefault();
    toTop();
  });

  if (!btn) return;

  function show(on) { btn.classList.toggle('is-on', !!on); }

  // Hauptweg: ein Messpunkt oben auf der Seite. Sobald er aus dem Blick ist,
  // sind wir weit genug unten. Das haengt weder an Scroll-Ereignissen noch an
  // requestAnimationFrame — beides kann in gedrosselten Tabs ausbleiben.
  if ('IntersectionObserver' in window) {
    var probe = document.createElement('div');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:120vh;pointer-events:none;visibility:hidden';
    document.body.appendChild(probe);
    new IntersectionObserver(function (entries) {
      show(!entries[0].isIntersecting);
    }).observe(probe);
  }

  // Zusaetzlich klassisch, falls der Beobachter fehlt.
  var last = 0, timer = null;
  function sync() {
    last = Date.now();
    show(window.scrollY > window.innerHeight * 1.2);
  }
  window.addEventListener('scroll', function () {
    if (Date.now() - last > 120) { sync(); return; }
    if (timer) return;
    timer = setTimeout(function () { timer = null; sync(); }, 120);
  }, { passive: true });
  window.addEventListener('resize', sync, { passive: true });
  sync();
})();

/* ==========================================================================
   MASSE & PASSFORM
   Groessenumschalter, Zahlen zaehlen hoch, passende Masslinie leuchtet rot.
   ========================================================================== */
(function () {
  var boxes = document.querySelectorAll('[data-fit]');
  if (!boxes.length) return;

  function fmt(n) {
    return (Math.round(n * 10) / 10).toString().replace('.', ',');
  }

  boxes.forEach(function (box) {
    var rows   = Array.prototype.slice.call(box.querySelectorAll('[data-fit-row]'));
    var btns   = Array.prototype.slice.call(box.querySelectorAll('[data-fit-size]'));
    var marks  = Array.prototype.slice.call(box.querySelectorAll('[data-mark]'));
    var timers = [];

    function markFor(key) {
      for (var i = 0; i < marks.length; i++) {
        if (marks[i].getAttribute('data-mark') === key) return marks[i];
      }
      return null;
    }

    // Zeilen ohne Masslinie bleiben ruhig.
    rows.forEach(function (row) {
      if (!markFor(row.getAttribute('data-fit-row'))) row.style.cursor = 'default';
    });

    function countTo(el, to, animate) {
      var from = parseFloat(String(el.textContent).replace(',', '.'));
      if (!animate || isNaN(from) || from === to) { el.textContent = fmt(to); return; }
      var t0 = null, dur = 320;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(from + (to - from) * e);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      // Falls der Browser keine Frames liefert: Wert trotzdem setzen.
      timers.push(setTimeout(function () { el.textContent = fmt(to); }, dur + 60));
    }

    function render(i, animate) {
      btns.forEach(function (b, bi) {
        var on = bi === i;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      rows.forEach(function (row) {
        var vals = (row.getAttribute('data-v') || '').split(',');
        var raw  = (vals[i] || '').trim();
        var num  = parseFloat(raw.replace(',', '.'));
        var el   = row.querySelector('[data-fit-val]');
        if (!el) return;
        if (isNaN(num)) { el.textContent = '–'; return; }
        countTo(el, num, animate);
        el.classList.remove('is-tick');
        if (animate) { void el.offsetWidth; el.classList.add('is-tick'); }
      });
    }

    function highlight(key) {
      marks.forEach(function (m) {
        m.classList.toggle('is-on', !!key && m.getAttribute('data-mark') === key);
      });
      rows.forEach(function (r) {
        r.classList.toggle('is-on', !!key && r.getAttribute('data-fit-row') === key);
      });
    }

    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { render(i, true); });
    });

    rows.forEach(function (row) {
      var key = row.getAttribute('data-fit-row');
      if (!markFor(key)) return;
      row.addEventListener('mouseenter', function () { highlight(key); });
      row.addEventListener('focus', function () { highlight(key); });
      row.addEventListener('mouseleave', function () { highlight(null); });
      row.addEventListener('blur', function () { highlight(null); });
      row.addEventListener('click', function () {
        var on = row.classList.contains('is-on');
        highlight(on ? null : key);
      });
    });

    var start = parseInt(box.getAttribute('data-start'), 10);
    render(isNaN(start) ? 0 : start, false);
  });
})();

/* ═══════════════════════════════════════════════════════════════════════════
   Aus der Nähe — Detail-Ausschnitte aus den Galeriebildern
   Sucht in den sichtbaren Galeriebildern (nach Farbe gefiltert) die Stellen mit
   der meisten Leder-Textur: keine Haut, kein Hintergrund, nicht unterhalb der Jacke.
   Gepinnte Ausschnitte (data-pins aus snippets/crop-data.liquid) haben Vorrang.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  var ZOOM = 2.6;
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  // background-position in % → Mittelpunkt des Ausschnitts. Bildbreite = ZOOM × Kastenbreite,
  // Kasten 4:5; die Höhe hängt vom Seitenverhältnis r = H/W des Bildes ab.
  function toPosX(cx) { return Math.min(1, Math.max(0, (ZOOM * cx - 0.5) / (ZOOM - 1))); }
  function toPosY(cy, r) {
    var ih = ZOOM * r, ch = 1.25;
    if (ih <= ch) return 0.5;
    return Math.min(1, Math.max(0, (cy * ih - ch / 2) / (ih - ch)));
  }

  function apply(box, picks, srcs) {
    var figs = $$('.crop__img', box);
    figs.forEach(function (f, i) {
      var p = picks[i];
      if (!p || !srcs[p.idx]) { f.classList.remove('is-set'); return; }
      var src = srcs[p.idx].replace(/width=\d+/, 'width=1600');
      f.style.setProperty('--src', 'url("' + src + '")');
      f.style.setProperty('--x', (toPosX(p.cx) * 100).toFixed(1) + '%');
      f.style.setProperty('--y', (toPosY(p.cy, 1.25) * 100).toFixed(1) + '%');
      var im = new Image();
      im.onload = function () {
        var r = im.naturalWidth ? im.naturalHeight / im.naturalWidth : 1.25;
        f.style.setProperty('--y', (toPosY(p.cy, r) * 100).toFixed(1) + '%');
        f.classList.add('is-set');
      };
      im.onerror = function () { f.classList.add('is-set'); };
      im.src = src;
    });
  }

  function load(src) {
    return new Promise(function (res) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = function () { res(null); };
      im.src = src.replace(/width=\d+/, 'width=300');
    });
  }

  function analyse(im, W) {
    var H = Math.round(W * im.naturalHeight / im.naturalWidth);
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, 0, 0, W, H);
    var d;
    try { d = x.getImageData(0, 0, W, H).data; } catch (e) { return null; }
    var n = W * H, g = new Float32Array(n), skin = new Uint8Array(n), bg = new Uint8Array(n);
    var br = [], bgc = [], bb = [], i, px, py, r, gg, b;
    for (i = 0; i < n; i++) {
      px = i % W; py = (i / W) | 0;
      if (px < 3 || py < 3 || px >= W - 3 || py >= H - 3) { br.push(d[i * 4]); bgc.push(d[i * 4 + 1]); bb.push(d[i * 4 + 2]); }
    }
    var med = function (a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; };
    var R = med(br), G = med(bgc), B = med(bb);
    for (i = 0; i < n; i++) {
      r = d[i * 4]; gg = d[i * 4 + 1]; b = d[i * 4 + 2];
      g[i] = 0.299 * r + 0.587 * gg + 0.114 * b;
      var mx = Math.max(r, gg, b), mn = Math.min(r, gg, b);
      if (r > 95 && gg > 40 && b > 20 && r > gg && r > b && (mx - mn) > 15 && Math.abs(r - gg) > 15 && r < 250) skin[i] = 1;
      if (Math.abs(r - R) + Math.abs(gg - G) + Math.abs(b - B) < 45) bg[i] = 1;
    }
    var e = new Float32Array(n), y, xx;
    for (y = 1; y < H - 1; y++) for (xx = 1; xx < W - 1; xx++) {
      i = y * W + xx; e[i] = Math.abs(g[i + 1] - g[i - 1]) + Math.abs(g[i + W] - g[i - W]);
    }
    // Hintergrund nur dort, wo die Fläche auch ruhig ist (Wand, Papier) — die Jacke selbst hat Struktur
    for (i = 0; i < n; i++) if (bg[i] && e[i] > 18) bg[i] = 0;
    return { d: d, W: W, H: H, skin: skin, bg: bg, e: e };
  }

  function jacketColor(A) {
    // Median der Vordergrundpixel im mittleren Band — robust gegen Besatz, Shirt und mottled Finishes
    var rs = [], gs = [], bs = [], y, x, i;
    for (y = Math.round(A.H * 0.30); y < A.H * 0.58; y++) for (x = Math.round(A.W * 0.15); x < A.W * 0.85; x++) {
      i = y * A.W + x;
      if (A.bg[i] || A.skin[i]) continue;
      rs.push(A.d[i * 4]); gs.push(A.d[i * 4 + 1]); bs.push(A.d[i * 4 + 2]);
    }
    if (rs.length < 20) return null;
    var med = function (a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; };
    return [med(rs), med(gs), med(bs)];
  }

  function auto(srcs) {
    var W = 120;
    return Promise.all(srcs.map(load)).then(function (ims) {
      var As = ims.map(function (im) { return im ? analyse(im, W) : null; });
      var first = As.filter(Boolean)[0];
      if (!first) return [];
      var jc = jacketColor(first);
      var cands = [];
      As.forEach(function (A, idx) {
        if (!A) return;
        var n = A.W * A.H, jk = new Uint8Array(n), i;
        if (jc) for (i = 0; i < n; i++) {
          var dr = A.d[i * 4] - jc[0], dg = A.d[i * 4 + 1] - jc[1], db = A.d[i * 4 + 2] - jc[2];
          if (Math.sqrt(dr * dr + dg * dg + db * db) < 70) jk[i] = 1;
        }
        var fw = Math.round(A.W / ZOOM), fh = Math.round(fw * 1.25), step = Math.max(2, Math.round(A.W * 0.04));
        for (var y = 0; y + fh <= A.H; y += step) for (var xx = 0; xx + fw <= A.W; xx += step) {
          var cy = (y + fh / 2) / A.H;
          if (cy > 0.68 || cy < 0.15) continue;
          var es = 0, ss = 0, bs = 0, js = 0, m = 0;
          for (var yy = y; yy < y + fh; yy += 2) for (var x2 = xx; x2 < xx + fw; x2 += 2) {
            i = yy * A.W + x2; es += A.e[i]; ss += A.skin[i]; bs += A.bg[i]; js += jk[i]; m++;
          }
          var edge = es / m, sk = ss / m, bgf = bs / m, jf = jc ? js / m : 0.5;
          cands.push({ idx: idx, cx: (xx + fw / 2) / A.W, cy: cy, sk: sk, bgf: bgf, jf: jf,
            score: edge * (0.1 + jf) - 300 * sk - 40 * bgf });
        }
      });
      cands.sort(function (a, b) { return b.score - a.score; });
      var picked = [];
      function pass(maxSame, minJf, maxBg, minDist) {
        for (var q = 0; q < cands.length && picked.length < 3; q++) {
          var c = cands[q];
          if (c.sk > 0.04 || c.jf < minJf || c.bgf > maxBg) continue;
          var same = picked.filter(function (p) { return p.idx === c.idx; });
          if (same.length >= maxSame) continue;
          if (same.some(function (p) { return Math.hypot(p.cx - c.cx, p.cy - c.cy) < minDist; })) continue;
          picked.push(c);
        }
      }
      // Erst streng (Jackenfarbe, wenig Hintergrund), dann lockerer — aber nie ohne Jackenanteil
      pass(2, 0.35, 0.45, 0.3); pass(3, 0.2, 0.6, 0.26); pass(3, 0.12, 0.7, 0.2);
      return picked;
    });
  }

  function run(box) {
    var gal = document.querySelector('[data-gallery]');
    if (!gal) return;
    var imgs = $$('figure:not([hidden]) img', gal);
    var srcs = imgs.map(function (i) { return i.getAttribute('src') || ''; }).filter(Boolean);
    if (!srcs.length) return;
    var all = $$('figure img', gal).map(function (i) { return i.getAttribute('src') || ''; });
    var pins = box.getAttribute('data-pins');
    if (pins) {
      try {
        var arr = JSON.parse(pins);
        if (!Array.isArray(arr)) {
          // Nach Farbe gepinnt: Schlüssel = gewählter Farbwert
          var colorEl = document.querySelector('[data-variant-picker] [data-option-value-for]');
          var cur = colorEl ? colorEl.textContent.trim() : '';
          arr = arr[cur] || arr[Object.keys(arr)[0]];
        }
        var picks = arr.map(function (p) { return { idx: p[0], cx: p[1], cy: p[2] }; });
        if (picks.every(function (p) { return all[p.idx]; })) { apply(box, picks, all); return; }
      } catch (e) {}
    }
    var token = box.__cropRun = (box.__cropRun || 0) + 1;
    auto(srcs).then(function (picks) {
      if (token !== box.__cropRun) return;
      if (picks.length < 3) {
        // Notnagel: feste Stellen im Bild des besten Treffers (sonst im ersten sichtbaren)
        var base = picks.length ? picks[0].idx : 0;
        var fill = [{ idx: base, cx: 0.5, cy: 0.42 }, { idx: base, cx: 0.36, cy: 0.52 }, { idx: base, cx: 0.66, cy: 0.5 }];
        for (var i = 0; i < 3 && picks.length < 3; i++) {
          var f = fill[i];
          if (picks.some(function (p) { return p.idx === f.idx && Math.hypot(p.cx - f.cx, p.cy - f.cy) < 0.18; })) continue;
          picks.push(f);
        }
      }
      apply(box, picks, srcs);
    });
  }

  function init() {
    var box = document.querySelector('[data-pstory]');
    if (!box) return;
    var gal = document.querySelector('[data-gallery]');
    var done = false;
    var kick = function () { if (done) return; done = true; run(box); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); kick(); }
      }, { rootMargin: '600px 0px' });
      io.observe(box);
    }
    // Sicherheitsnetz: spätestens kurz nach dem Laden rechnen (Hintergrund-Tabs melden kein Intersecting)
    var late = function () { setTimeout(kick, 1200); };
    if (document.readyState === 'complete') late(); else window.addEventListener('load', late);
    if (gal) gal.addEventListener('gal:refresh', function () { if (done) run(box); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Kartenswatches: Farbe wechselt Bild und Link der Produktkarte */
(function () {
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.pcard__swatches .sw[data-sw-color]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.pcard'); if (!card) return;
    var a = card.querySelector('.img-a'), b = card.querySelector('.img-b');
    var img = sw.getAttribute('data-sw-img'), img2 = sw.getAttribute('data-sw-img2'), url = sw.getAttribute('data-sw-url');
    if (a && img) { a.removeAttribute('srcset'); a.removeAttribute('sizes'); a.src = img; }
    if (b) { if (img2) { b.removeAttribute('srcset'); b.removeAttribute('sizes'); b.src = img2; b.style.visibility = ''; } else if (img) { b.removeAttribute('srcset'); b.src = img; } }
    if (url) { card.querySelectorAll('a[href]').forEach(function (l) { l.href = url; }); }
    card.querySelectorAll('.pcard__swatches .sw').forEach(function (s) { s.removeAttribute('data-active'); });
    sw.setAttribute('data-active', '');
    var mat = card.querySelector('.pcard__mat');
    if (mat && mat.getAttribute('data-base') === null) mat.setAttribute('data-base', mat.textContent);
    if (mat) { var base = mat.getAttribute('data-base'); var parts = base.split(' · '); mat.textContent = parts[0] + ' · ' + sw.getAttribute('data-sw-color'); }
  });
})();

/* Farbpunkte auf der Karte: Bild, Link, Leder-Zeile, Preis und Schnell-Grössen
   der Karte wechseln — ohne die Seite zu verlassen. Zweiter Klick auf den
   aktiven Punkt öffnet die Jacke. */
(function () {
  document.addEventListener('click', function (e) {
    var d = e.target.closest('.pcard [data-cdot]');
    if (!d) return;
    var card = d.closest('.pcard'); if (!card) return;
    if (d.classList.contains('is-on')) return; // aktive Farbe: normal öffnen
    e.preventDefault();
    var url = (window.tighaFixUrl || function (u) { return u; })(d.getAttribute('data-url'));
    var a = card.querySelector('.img-a'), b = card.querySelector('.img-b');
    var img = d.getAttribute('data-img'), img2 = d.getAttribute('data-img2');
    function set(el, src) { if (!el || !src) return; el.removeAttribute('srcset'); el.removeAttribute('sizes'); el.src = src; el.style.visibility = ''; }
    set(a, img); set(b, img2 || img);
    card.querySelectorAll('.pcard__media, .pcard__name a').forEach(function (l) { if (url) l.href = url; });
    var qv = card.querySelector('[data-quickview]'); if (qv && url) qv.setAttribute('data-quickview', url.split('?')[0]);
    var mat = card.querySelector('.pcard__mat'); var m = d.getAttribute('data-mat'); if (mat && m) mat.textContent = m;
    var pr = card.querySelector('.pcard__prices .price__now'); var p = d.getAttribute('data-price'); if (pr && p) pr.textContent = p;
    var h = d.getAttribute('data-handle'); if (h) card.setAttribute('data-product-handle', h);
    // Schnell-Grössen neu setzen
    var qs = card.querySelector('.pcard__qs-v'); var v = d.getAttribute('data-v');
    if (qs && v) {
      qs.innerHTML = '';
      v.split('|').forEach(function (row) {
        if (!row) return; var f = row.split('~'); var s = document.createElement('span');
        s.className = 'pcard__qs-s' + (f[2] === 'true' ? '' : ' is-out'); s.textContent = f[0];
        if (f[2] === 'true') { s.setAttribute('role', 'button'); s.setAttribute('tabindex', '0'); s.setAttribute('data-card-add', f[1]); s.setAttribute('aria-label', tighaL('cardAddSize', 'Grösse {s} in den Warenkorb', { s: f[0] })); }
        qs.appendChild(s);
      });
    }
    card.querySelectorAll('[data-cdot]').forEach(function (x) { x.classList.remove('is-on'); });
    d.classList.add('is-on');
  });
})();

/* ── Merkliste: die Seite ─────────────────────────────────────────────────
   Liest die gemerkten Handles und baut die Karten aus den Produktdaten,
   die in der Seite liegen. Ohne Daten bleibt die Liste leer statt kaputt. */
(function () {
  'use strict';

  function fmt(cents) {
    var f = (window.tigha && window.tigha.moneyFormat) || '{{amount_with_comma_separator}} €';
    var v = (Number(cents) / 100).toFixed(2).replace('.', ',');
    return f.indexOf('{{') === -1 ? v + ' €' : f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function initWishlistPage(scope) {
    var root = (scope || document).querySelector('[data-wishlist-page]');
    if (!root || root.dataset.wlReady === '1') return;
    root.dataset.wlReady = '1';

    var dataEl = root.querySelector('[data-wl-data]');
    var list   = root.querySelector('[data-wl-list]');
    var empty  = root.querySelector('[data-wl-empty]');
    var save   = root.querySelector('[data-wl-save]');
    var countE = document.querySelector('[data-wl-count]');
    var tagsIn = root.querySelector('[data-wl-tags]');
    var noteIn = root.querySelector('[data-wl-note]');
    var DATA = { products: {} };

    try { DATA = JSON.parse(dataEl.textContent) || DATA; } catch (e) {}

    function card(handle) {
      var p = DATA.products[handle];
      if (!p) return null;
      var el = document.createElement('article');
      el.className = 'wl-item';
      el.setAttribute('data-wl-item', handle);

      /* Je Option eine eigene Auswahl: Grösse, und wo es sie gibt, die Ausführung.
         Alle Felder gleich breit, damit die Zeilen untereinander stehen. */
      var opts = (p.options || []).filter(function (o) {
        return o.values && o.values.length && !(o.values.length === 1 && o.values[0] === 'Default Title');
      });

      function selects() {
        var out = '';
        for (var i = 0; i < 2; i++) {
          var o = opts[i];
          if (!o) { out += '<span class="wl-sel wl-sel--empty" aria-hidden="true"></span>'; continue; }
          var id = 'wl-' + handle + '-' + i;
          out += '<span class="wl-sel">' +
                   '<label class="visually-hidden" for="' + id + '">' + o.name + '</label>' +
                   '<select id="' + id + '" data-wl-opt="' + i + '">' +
                     '<option value="">' + tighaL('chooseOpt', '{o} wählen', { o: o.name }) + '</option>' +
                     o.values.map(function (v) {
                       return '<option value="' + String(v).replace(/"/g, '&quot;') + '">' + v + '</option>';
                     }).join('') +
                   '</select>' +
                 '</span>';
        }
        return out;
      }

      var onSale = p.compare && p.compare > p.price;
      el.innerHTML =
        '<a class="wl-item__m" href="' + p.url + '">' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<span class="wl-item__ph"></span>') +
        '</a>' +
        '<div class="wl-item__b">' +
          '<h2 class="wl-item__n"><a href="' + p.url + '">' + p.title + '</a></h2>' +
          (p.type ? '<p class="wl-item__t">' + p.type + '</p>' : '') +
          '<p class="wl-item__p">' +
            (onSale ? '<span class="wl-item__was">' + fmt(p.compare) + '</span> ' : '') +
            '<span>' + fmt(p.price) + '</span>' +
          '</p>' +
          (p.available
            ? '<div class="wl-item__buy" data-wl-buy>' +
                selects() +
                '<button type="button" class="wl-add" data-wl-add>' + tighaL('addToCart', 'In den Warenkorb') + '</button>' +
              '</div>' +
              '<p class="wl-item__msg mono" data-wl-msg hidden></p>'
            : '<p class="wl-item__out mono">' + tighaL('wlOut', 'Zurzeit ausverkauft — wir melden uns, wenn sie zurück ist.') + '</p>') +
        '</div>' +
        '<button type="button" class="wl-item__x" data-wl-remove aria-label="' + tighaL('wlRemove', 'Von der Merkliste nehmen') + '">×</button>';
      return el;
    }

    function render() {
      var handles = Wish.read().filter(function (h) { return !!DATA.products[h]; });
      list.innerHTML = '';
      handles.forEach(function (h) {
        var c = card(h);
        if (c) list.appendChild(c);
      });
      var n = handles.length;
      list.hidden  = n === 0;
      empty.hidden = n !== 0;
      if (save) save.hidden = n === 0;
      if (countE) {
        countE.hidden = n === 0;
        countE.textContent = n === 1 ? '1 Modell' : n + ' Modelle';
      }
      if (tagsIn) tagsIn.value = ['wishlist'].concat(handles).join(', ');
      if (noteIn) {
        noteIn.value = 'Merkliste: ' + handles.map(function (h) {
          return DATA.products[h] ? DATA.products[h].title + ' (' + h + ')' : h;
        }).join(' · ');
      }
    }

    list.addEventListener('click', function (e) {
      var item = e.target.closest('[data-wl-item]');
      if (!item) return;
      var handle = item.getAttribute('data-wl-item');

      if (e.target.closest('[data-wl-remove]')) {
        Wish.remove(handle);
        return;
      }
      if (e.target.closest('[data-wl-add]')) {
        var p = DATA.products[handle];
        var sels = Array.prototype.slice.call(item.querySelectorAll('[data-wl-opt]'));
        var missing = sels.filter(function (s) { return !s.value; });
        if (missing.length) {
          missing.forEach(function (s) { s.classList.add('is-missing'); });
          missing[0].focus();
          say(item, missing.length > 1 ? tighaL('wlChooseAll', 'Bitte erst alles auswählen.') : tighaL('wlChooseOne', 'Bitte erst {o} wählen.', { o: optName(p, missing[0]) }));
          return;
        }
        var v = match(p, sels);
        if (!v) { say(item, tighaL('wlNoCombo', 'Diese Kombination gibt es nicht.')); return; }
        if (!v.available) { say(item, tighaL('wlVariantOut', 'Diese Ausführung ist zurzeit ausverkauft.')); return; }
        say(item, '');
        var fd = new FormData();
        fd.append('id', v.id);
        fd.append('quantity', 1);
        if (window.tighaCart) window.tighaCart.add(fd, e.target.closest('[data-wl-add]'));
      }
    });

    function optName(p, sel) {
      var i = Number(sel.getAttribute('data-wl-opt'));
      var o = (p && p.options && p.options[i]) || null;
      return o ? o.name : tighaL('wlASize', 'eine Grösse');
    }

    function match(p, sels) {
      var want = sels.map(function (s) { return s.value; });
      return (p.variants || []).filter(function (v) {
        return want.every(function (w, i) { return (v.o || [])[i] === w; });
      })[0] || null;
    }

    function say(item, msg) {
      var el = item.querySelector('[data-wl-msg]');
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
    }

    list.addEventListener('change', function (e) {
      if (!e.target.matches('[data-wl-opt]')) return;
      e.target.classList.remove('is-missing');
      var item = e.target.closest('[data-wl-item]');
      var p = DATA.products[item.getAttribute('data-wl-item')];
      var sels = Array.prototype.slice.call(item.querySelectorAll('[data-wl-opt]'));
      /* Zweite Auswahl: was es mit der ersten nicht gibt, wird ausgegraut */
      sels.forEach(function (s, i) {
        var others = sels.filter(function (x, j) { return j !== i && x.value; });
        Array.prototype.slice.call(s.options).forEach(function (op) {
          if (!op.value) return;
          var ok = (p.variants || []).some(function (v) {
            if ((v.o || [])[i] !== op.value) return false;
            return others.every(function (x) {
              var j = Number(x.getAttribute('data-wl-opt'));
              return (v.o || [])[j] === x.value;
            }) && v.available;
          });
          op.disabled = !ok;
        });
      });
      if (sels.every(function (s) { return s.value; })) say(item, '');
    });

    document.addEventListener('tigha:wishlist', render);
    render();
  }

  document.addEventListener('DOMContentLoaded', function () { initWishlistPage(document); });
  document.addEventListener('shopify:section:load', function (e) { initWishlistPage(e.target); });
  window.tighaWishlistPage = initWishlistPage;
})();


/* ── Rückgabe & Umtausch: die beiden Wege ─────────────────────────────────
   Umtausch ist offen, wenn die Seite aufgeht. Die Rückgabe steht daneben,
   nicht darüber. */
(function () {
  'use strict';

  function initReturns(scope) {
    var root = (scope || document).querySelector('[data-ret-switch]');
    if (!root || root.dataset.retReady === '1') return;
    root.dataset.retReady = '1';
    var page = root.closest('.ret') || document;

    function show(which) {
      page.querySelectorAll('[data-ret-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-ret-panel') !== which;
      });
      root.querySelectorAll('[data-ret-tab]').forEach(function (b) {
        b.setAttribute('aria-selected', b.getAttribute('data-ret-tab') === which ? 'true' : 'false');
      });
    }

    page.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ret-tab]');
      if (!b) return;
      show(b.getAttribute('data-ret-tab'));
      if (!root.contains(b)) {
        var t = page.querySelector('[data-ret-switch]');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    /* Nach dem Absenden bleibt der Weg offen, über den gesendet wurde */
    if (location.hash === '#ReturnForm' || location.hash === '#contact_form-ReturnForm') show('r');
  }

  document.addEventListener('DOMContentLoaded', function () { initReturns(document); });
  document.addEventListener('shopify:section:load', function (e) { initReturns(e.target); });
  window.tighaReturns = initReturns;
})();


/* ── Händler: suchen und nach Entfernung sortieren ────────────────────────
   Ohne Standortfreigabe bleibt die Reihenfolge, wie sie im Theme steht. */
(function () {
  'use strict';

  function km(a, b, c, d) {
    var R = 6371, p = Math.PI / 180;
    var dLat = (c - a) * p, dLng = (d - b) * p;
    var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(a * p) * Math.cos(c * p) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return Math.round(R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x)));
  }

  function initStores(scope) {
    var root = (scope || document).querySelector('[data-stores]');
    if (!root || root.dataset.stReady === '1') return;
    root.dataset.stReady = '1';

    var list  = root.querySelector('[data-store-list]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-store-card]'));
    var q     = root.querySelector('[data-store-q]');
    var near  = root.querySelector('[data-store-near]');
    var hint  = root.querySelector('[data-store-hint]');
    var none  = root.querySelector('[data-store-empty]');
    if (!cards.length) return;

    function filter() {
      var v = (q && q.value || '').trim().toLowerCase();
      var shown = 0;
      cards.forEach(function (c) {
        var hit = !v || (c.getAttribute('data-store-text') || '').indexOf(v) > -1;
        c.hidden = !hit;
        if (hit) shown++;
      });
      if (none) none.hidden = shown !== 0;
      root.querySelectorAll('[data-store-dot]').forEach(function (d) {
        var card = root.querySelector('[data-store-id="' + d.getAttribute('data-store-dot') + '"]');
        d.hidden = !!(card && card.hidden);
      });
    }

    if (q) q.addEventListener('input', filter);

    if (near) near.addEventListener('click', function () {
      if (!navigator.geolocation) {
        if (hint) { hint.hidden = false; hint.textContent = tighaL('geoNone', 'Dein Browser gibt den Standort nicht her. Tipp einfach deinen Ort ein.'); }
        return;
      }
      near.classList.add('loading');
      navigator.geolocation.getCurrentPosition(function (pos) {
        near.classList.remove('loading');
        var la = pos.coords.latitude, ln = pos.coords.longitude, rated = 0;
        cards.forEach(function (c) {
          var a = parseFloat(c.getAttribute('data-lat')), b = parseFloat(c.getAttribute('data-lng'));
          var d = c.querySelector('[data-store-dist]');
          if (isNaN(a) || isNaN(b)) { c._d = 1e9; return; }
          c._d = km(la, ln, a, b);
          rated++;
          if (d) { d.hidden = false; d.textContent = tighaL('kmAway', '{d} km entfernt', { d: c._d }); }
        });
        cards.slice().sort(function (x, y) { return (x._d || 1e9) - (y._d || 1e9); })
             .forEach(function (c) { list.appendChild(c); });
        if (hint) {
          hint.hidden = false;
          hint.textContent = rated ? tighaL('geoSorted', 'Nach Entfernung sortiert.') : tighaL('geoMissing', 'Für diese Händler fehlen die Koordinaten.');
        }
      }, function () {
        near.classList.remove('loading');
        if (hint) { hint.hidden = false; hint.textContent = tighaL('geoDenied', 'Kein Standort freigegeben. Tipp deinen Ort oder deine Postleitzahl ein.'); }
      }, { timeout: 8000, maximumAge: 300000 });
    });

    root.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-store-dot]');
      if (!dot) return;
      var card = root.querySelector('[data-store-id="' + dot.getAttribute('data-store-dot') + '"]');
      if (!card) return;
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      card.classList.add('is-hl');
      setTimeout(function () { card.classList.remove('is-hl'); }, 1400);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initStores(document); });
  document.addEventListener('shopify:section:load', function (e) { initStores(e.target); });
  window.tighaStores = initStores;
})();


/* ── Vertrag widerrufen: zweite Stufe ─────────────────────────────────────
   Das Gesetz will eine eigene Bestätigungs-Schaltfläche. Der erste Knopf
   sendet deshalb nicht, sondern prüft die Pflichtfelder und legt darunter die
   Zusammenfassung auf — mit dem echten Absende-Knopf.
   Ohne JavaScript bleibt die Zusammenfassung sichtbar und das Formular sendet
   direkt; die Seite funktioniert also auch dann. */
(function () {
  'use strict';

  function initWithdrawal(scope) {
    var form = (scope || document).querySelector('.wd-form');
    if (!form || form.dataset.wdReady === '1') return;
    form.dataset.wdReady = '1';

    var review  = form.querySelector('[data-wd-review]');
    var confirm = form.querySelector('[data-wd-confirm]');
    var back    = form.querySelector('[data-wd-back]');
    var summary = form.querySelector('[data-wd-summary]');
    if (!review || !confirm) return;

    /* Teilwiderruf: das Artikelfeld erscheint nur, wenn es gebraucht wird */
    var items = form.querySelector('[data-wd-items]');
    form.addEventListener('change', function (e) {
      var r = e.target.closest('[data-wd-scope]');
      if (!r || !items) return;
      var part = r.getAttribute('data-wd-scope') === 'part';
      items.hidden = !part;
      var ta = items.querySelector('textarea');
      if (ta) { ta.required = part; if (part) ta.focus(); }
    });

    function label(el) {
      var l = el.closest('.f') && el.closest('.f').querySelector('label');
      if (!l) return el.name || '';
      return l.textContent.replace(/freiwillig|optional/i, '').trim();
    }

    function build() {
      if (!summary) return;
      summary.innerHTML = '';
      var rows = [];
      form.querySelectorAll('input[name], textarea[name], select[name]').forEach(function (el) {
        if (el.type === 'hidden') return;
        if (el.type === 'radio' && !el.checked) return;
        var v = (el.value || '').trim();
        if (!v) return;
        var key = el.type === 'radio'
          ? tighaL('wdScope', 'Umfang')
          : label(el) || el.name.replace(/^contact\[|\]$/g, '');
        rows.push([key, v]);
      });
      rows.forEach(function (r) {
        var dt = document.createElement('dt'); dt.textContent = r[0];
        var dd = document.createElement('dd'); dd.textContent = r[1];
        summary.appendChild(dt); summary.appendChild(dd);
      });
    }

    review.addEventListener('click', function () {
      var bad = null;
      form.querySelectorAll('[data-wd-req]').forEach(function (el) {
        el.classList.remove('is-bad');
        if (!el.value.trim() || (el.type === 'email' && !el.checkValidity())) {
          el.classList.add('is-bad');
          if (!bad) bad = el;
        }
      });
      if (items && !items.hidden) {
        var ta = items.querySelector('textarea');
        if (ta && !ta.value.trim()) { ta.classList.add('is-bad'); if (!bad) bad = ta; }
      }
      if (bad) { bad.focus(); bad.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }

      build();
      confirm.hidden = false;
      review.hidden = true;
      confirm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var ok = confirm.querySelector('button[type=submit]');
      if (ok) ok.focus();
    });

    if (back) back.addEventListener('click', function () {
      confirm.hidden = true;
      review.hidden = false;
      review.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    form.addEventListener('input', function (e) {
      if (e.target.classList) e.target.classList.remove('is-bad');
    });
  }

  /* Bestätigungsseite: Zeitstempel und Druck */
  function initWithdrawalDone(scope) {
    var stamp = (scope || document).querySelector('[data-wd-date]');
    if (stamp && stamp.dataset.wdSet !== '1') {
      stamp.dataset.wdSet = '1';
      try {
        stamp.textContent = tighaL('wdStamp', '{d} Uhr', { d: new Date().toLocaleString(window.tighaLang === 'de' ? 'de-DE' : window.tighaLang, {
          day: '2-digit', month: '2-digit', year: 'numeric',
          hour: '2-digit', minute: '2-digit'
        }) });
      } catch (e) { stamp.textContent = new Date().toString(); }
    }
    var p = (scope || document).querySelector('[data-wd-print]');
    if (p && p.dataset.wdReady !== '1') {
      p.dataset.wdReady = '1';
      p.addEventListener('click', function () { window.print(); });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWithdrawal(document); initWithdrawalDone(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    initWithdrawal(e.target); initWithdrawalDone(e.target);
  });
  window.tighaWithdrawal = initWithdrawal;
})();


/* ── Rechnung: Ansicht und Druck ──────────────────────────────────────────
   Kein PDF-Dienst, keine App: Der Browser kann das. Beim Drucken blendet
   assets/account.css alles ausser dem Beleg aus — „Als PDF sichern" steht in
   jedem Druckdialog, auch auf dem Handy. */
(function () {
  'use strict';

  function initInvoice(scope) {
    var box = (scope || document).querySelector('[data-invoice]');
    if (!box || box.dataset.invReady === '1') return;
    box.dataset.invReady = '1';

    var opener = document.querySelector('[data-invoice-open]');
    var last = null;

    function open() {
      last = document.activeElement;
      box.hidden = false;
      document.documentElement.classList.add('has-invoice');
      var c = box.querySelector('[data-invoice-close]');
      if (c) c.focus();
    }
    function close() {
      box.hidden = true;
      document.documentElement.classList.remove('has-invoice');
      if (last && last.focus) last.focus();
    }

    if (opener) opener.addEventListener('click', open);
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('[data-invoice-close]')) close();
      if (e.target.closest('[data-invoice-print]')) window.print();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) close();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initInvoice(document); });
  document.addEventListener('shopify:section:load', function (e) { initInvoice(e.target); });
  window.tighaInvoice = initInvoice;
})();


/* ── Bestellung: Sendungsnummer kopieren ────────────────────────────────── */
(function () {
  'use strict';

  function initOrder(scope) {
    var root = (scope || document).querySelector('[data-order-status]');
    if (!root || root.dataset.ostReady === '1') return;
    root.dataset.ostReady = '1';

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-copy]');
      if (!b) return;
      var v = b.getAttribute('data-copy');
      var done = function () {
        var t = b.textContent;
        b.textContent = tighaL('copied', 'Kopiert');
        setTimeout(function () { b.textContent = t; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(v).then(done, done);
      } else {
        var i = document.createElement('input');
        i.value = v; document.body.appendChild(i); i.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(i); done();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initOrder(document); });
  document.addEventListener('shopify:section:load', function (e) { initOrder(e.target); });
  window.tighaOrder = initOrder;
})();


/* ── Adressen: bearbeiten ohne Seitenwechsel ────────────────────────────── */
(function () {
  'use strict';

  function initAddresses(scope) {
    var root = (scope || document).querySelector('[data-addresses]');
    if (!root || root.dataset.adrReady === '1') return;
    root.dataset.adrReady = '1';

    /* Land vorauswählen — Shopify liefert die Liste, nicht die Auswahl */
    root.querySelectorAll('select[data-default]').forEach(function (sel) {
      var d = sel.getAttribute('data-default');
      if (d) sel.value = d;
    });

    var newBox = root.querySelector('[data-addr-form]');

    root.addEventListener('click', function (e) {
      var open = e.target.closest('[data-addr-new]');
      if (open && newBox) {
        newBox.hidden = false;
        var first = newBox.querySelector('input');
        if (first) first.focus();
        newBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (e.target.closest('[data-addr-cancel]') && newBox) { newBox.hidden = true; return; }

      var edit = e.target.closest('[data-addr-edit]');
      if (edit) {
        var id = edit.getAttribute('data-addr-edit');
        var panel = root.querySelector('[data-addr-panel="' + id + '"]');
        var card = edit.closest('.addr');
        if (panel) {
          panel.hidden = false;
          if (card) card.classList.add('is-editing');
          var f = panel.querySelector('input');
          if (f) f.focus();
        }
        return;
      }

      var close = e.target.closest('[data-addr-close]');
      if (close) {
        var cid = close.getAttribute('data-addr-close');
        var cp = root.querySelector('[data-addr-panel="' + cid + '"]');
        if (cp) cp.hidden = true;
        var cc = close.closest('.addr');
        if (cc) cc.classList.remove('is-editing');
        return;
      }

      var del = e.target.closest('[data-confirm]');
      if (del && !window.confirm(del.getAttribute('data-confirm'))) e.preventDefault();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initAddresses(document); });
  document.addEventListener('shopify:section:load', function (e) { initAddresses(e.target); });
  window.tighaAddresses = initAddresses;
})();
